import React from 'react';
import {
  Button,
  IconButton,
  LinearGradient,
  NumberInput,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  TextInput,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { ActivityIndicator, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as DefaultApi from '../apis/DefaultApi.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import SideMenuBlock from '../components/SideMenuBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import * as AdditionalCategoryExpenses from '../custom-files/AdditionalCategoryExpenses';
import addOrRemove from '../global-functions/addOrRemove';
import calculateCashOnHandFlow from '../global-functions/calculateCashOnHandFlow';
import calculatePercentIncome from '../global-functions/calculatePercentIncome';
import cashOnHand from '../global-functions/cashOnHand';
import checkScreenMode from '../global-functions/checkScreenMode';
import createObjectForPost from '../global-functions/createObjectForPost';
import createStartingBalance from '../global-functions/createStartingBalance';
import customCategory from '../global-functions/customCategory';
import findColumnRowNumber from '../global-functions/findColumnRowNumber';
import findIndextAllCategories from '../global-functions/findIndextAllCategories';
import formatNumber from '../global-functions/formatNumber';
import generateDates from '../global-functions/generateDates';
import getCurrentYear from '../global-functions/getCurrentYear';
import getInitValue from '../global-functions/getInitValue';
import initTableRows from '../global-functions/initTableRows';
import mergeCategoriesNumbers from '../global-functions/mergeCategoriesNumbers';
import newFormatDate from '../global-functions/newFormatDate';
import removeFromCategories from '../global-functions/removeFromCategories';
import removeFromNumberInputs from '../global-functions/removeFromNumberInputs';
import sortCategories from '../global-functions/sortCategories';
import timestampToISO from '../global-functions/timestampToISO';
import updateTableRows from '../global-functions/updateTableRows';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import useWindowDimensions from '../utils/useWindowDimensions';

const ExpensesFormScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [allCategoriesFinance, setAllCategoriesFinance] = React.useState([]);
  const [allCategoriesOperating, setAllCategoriesOperating] = React.useState(
    []
  );
  const [allCategoriesOther, setAllCategoriesOther] = React.useState([]);
  const [allCategoriesPayment, setAllCategoriesPayment] = React.useState('');
  const [defaultExpenseCategories, setDefaultExpenseCategories] =
    React.useState([]);
  const [financeData, setFinanceData] = React.useState('');
  const [incomeData, setIncomeData] = React.useState([]);
  const [isFetching, setIsFetching] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [monthlyStartingBalance, setMonthlyStartingBalance] =
    React.useState('');
  const [newCategory, setNewCategory] = React.useState('');
  const [numberInputs, setNumberInputs] = React.useState([]);
  const [numberInputsFinance, setNumberInputsFinance] = React.useState([]);
  const [numberInputsOperating, setNumberInputsOperating] = React.useState([]);
  const [numberInputsOther, setNumberInputsOther] = React.useState([]);
  const [numberInputsPaymentForCost, setNumberInputsPaymentForCost] =
    React.useState([]);
  const [operatingData, setOperatingData] = React.useState('');
  const [otherData, setOtherData] = React.useState('');
  const [paymentData, setPaymentData] = React.useState('');
  const [reFetch, setReFetch] = React.useState(false);
  const [reRender, setReRender] = React.useState(false);
  const [selectedIndexCogs, setSelectedIndexCogs] = React.useState([]);
  const [selectedIndexFinance, setSelectedIndexFinance] = React.useState([]);
  const [selectedIndexOperating, setSelectedIndexOperating] = React.useState(
    []
  );
  const [selectedIndexOther, setSelectedIndexOther] = React.useState([]);
  const [toggleAddCategoryFinance, setToggleAddCategoryFinance] =
    React.useState(false);
  const [toggleAddCategoryOperating, setToggleAddCategoryOperating] =
    React.useState(false);
  const [toggleAddCategoryOther, setToggleAddCategoryOther] =
    React.useState(false);
  const [toggleNewCategoryFinance, setToggleNewCategoryFinance] =
    React.useState(false);
  const [toggleNewCategoryOperating, setToggleNewCategoryOperating] =
    React.useState(false);
  const [toggleNewCategoryOther, setToggleNewCategoryOther] =
    React.useState(false);
  const [totalCashPaidOut, setTotalCashPaidOut] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalFinancePerCategory, setTotalFinancePerCategory] = React.useState([
    0, 0, 0, 0,
  ]);
  const [totalFinancePerMonth, setTotalFinancePerMonth] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalOperatingPerCategory, setTotalOperatingPerCategory] =
    React.useState([
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0,
    ]);
  const [totalOperatingPerMonth, setTotalOperatingPerMonth] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalOtherPerCategory, setTotalOtherPerCategory] = React.useState([
    0, 0, 0, 0, 0, 0,
  ]);
  const [totalPaymentForCostPerCetagory, setTotalPaymentForCostPerCetagory] =
    React.useState([0]);
  const [totalPaymentForCostPerMonth, setTotalPaymentForCostPerMonth] =
    React.useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [usersCategories, setUsersCategories] = React.useState([]);
  const addNewRow = matrix => {
    const newRow = new Array(matrix[0].length).fill(0);

    matrix.push(newRow);

    return matrix;
  };

  const calculateForPieChart = (
    productExpense,
    financeExpense,
    operatingExpense,
    payrollExpense
  ) => {
    const calculateTotal = expenseArray => {
      if (!Array.isArray(expenseArray)) {
        console.error('Expected an array, but received:', expenseArray);
        return 0;
      }
      return expenseArray.reduce((acc, val) => acc + (val || 0), 0);
    };

    const totalProductExpense = calculateTotal(productExpense);
    const totalFinanceExpense = calculateTotal(financeExpense);
    const totalOperatingExpense = calculateTotal(operatingExpense);
    const totalPayrollExpense = calculateTotal(payrollExpense);

    const totalExpenses =
      totalProductExpense +
      totalFinanceExpense +
      totalOperatingExpense +
      totalPayrollExpense;

    let data = [
      {
        name: 'Finance Expense',
        value: (totalFinanceExpense / totalExpenses) * 100,
      },
      {
        name: 'Operating Expense',
        value: (totalOperatingExpense / totalExpenses) * 100,
      },
      {
        name: 'Payroll Expense',
        value: (totalPayrollExpense / totalExpenses) * 100,
      },
      {
        name: 'Product Expense',
        value: (totalProductExpense / totalExpenses) * 100,
      },
    ];

    data = data.map(item => ({
      name: item.name,
      value: Math.round(item.value),
    }));

    const totalRounded = data.reduce((acc, item) => acc + item.value, 0);
    const difference = 100 - totalRounded;

    if (difference !== 0) {
      const maxIndex = data.reduce(
        (maxIdx, item, idx, arr) =>
          item.value > arr[maxIdx].value ? idx : maxIdx,
        0
      );
      data[maxIndex].value += difference;
    }

    return data;
  };

  const cellWidth = () => {
    const windowWidth = window.innerWidth;
    const result = (windowWidth - windowWidth * 0.15 - 515) / 14;
    return result;
  };

  const customCategortyExpenses = (categories, newTitle) => {
    const generateUniqueTitle = title => {
      let uniqueTitle = title;
      let counter = 1;

      while (
        categories.some(item => {
          const itemTitle = item._expense_heads
            ? item._expense_heads.title
            : item.title;
          return itemTitle === uniqueTitle;
        })
      ) {
        uniqueTitle = `${title} ${++counter}`;
      }

      return uniqueTitle;
    };

    const finalTitle = generateUniqueTitle(newTitle);

    const newItem = {
      id: null,
      created_at: Date.now(),
      _expense_heads: { title: finalTitle },
      default: false,
      custom: true,
    };

    categories.push(newItem);

    return categories;
  };

  const findIndexExpense = (arr, titleObj) => {
    const titleToCompare = titleObj._expense_heads
      ? titleObj._expense_heads.title
      : titleObj.title;

    return arr.findIndex(item => {
      const itemTitle = item._expense_heads
        ? item._expense_heads.title
        : item.title;
      return itemTitle === titleToCompare;
    });
  };

  const getMonthlyIncome = (totalIncome, startingDate) => {
    const result = new Array(12).fill(0);
    const startDate = new Date(startingDate);
    const startYear = startDate.getUTCFullYear();
    const startMonth = startDate.getUTCMonth();

    for (let i = 0; i < totalIncome.length; i++) {
      const incomeDate = new Date(totalIncome[i].monthly_income_month);
      const incomeYear = incomeDate.getUTCFullYear();
      const incomeMonth = incomeDate.getUTCMonth();

      const monthDifference =
        (incomeYear - startYear) * 12 + (incomeMonth - startMonth);

      if (monthDifference >= 0 && monthDifference < 12) {
        result[monthDifference] = totalIncome[i].monthly_income_amount;
      }
    }

    return result;
  };

  const prefillNumberExpense = (data, categories, startingDate) => {
    if (!Array.isArray(categories)) {
      console.error('Categories is not an array:', categories);
      return [];
    }

    const startDate = new Date(startingDate);

    if (isNaN(startDate.getTime())) {
      return [];
    }

    const getMonthIndex = (recordMonth, startDate) => {
      const recordDate = new Date(recordMonth);

      if (isNaN(recordDate.getTime())) {
        return -1;
      }

      const monthsDiff =
        (recordDate.getFullYear() - startDate.getFullYear()) * 12 +
        (recordDate.getMonth() - startDate.getMonth());
      return monthsDiff >= 0 ? monthsDiff : -1;
    };

    const defaultCategories = categories.filter(cat => cat.default_value);
    const customCategories = categories.filter(cat => cat.custom_value);

    const defaultNumberInputs = defaultCategories.map(category => {
      const id = category.id;
      const monthArray = Array(12).fill(0);

      const dataItems = data.filter(item => item.user_expense_heads_id === id);

      dataItems.forEach(item => {
        item.data.forEach(record => {
          const monthIndex = getMonthIndex(
            new Date(record.month).toISOString(),
            startDate
          );
          if (monthIndex >= 0 && monthIndex < 12) {
            monthArray[monthIndex] = record.amount || 0;
          }
        });
      });

      return monthArray;
    });

    const customNumberInputs = customCategories.map(category => {
      const id = category.id;
      const monthArray = Array(12).fill(0);

      const dataItems = data.filter(
        item => item.custom_expense_heads_id === id
      );

      dataItems.forEach(item => {
        item.data.forEach(record => {
          const monthIndex = getMonthIndex(
            new Date(record.month).toISOString(),
            startDate
          );
          if (monthIndex >= 0 && monthIndex < 12) {
            monthArray[monthIndex] = record.amount || 0;
          }
        });
      });

      return monthArray;
    });

    return [...defaultNumberInputs, ...customNumberInputs];
  };

  const pullStartingBalance = (data, startingDate) => {
    const result = [];

    let currentDate = new Date(startingDate);
    currentDate.setUTCDate(1);

    for (let i = 0; i < 12; i++) {
      const matchingRecord = data.find(record => {
        const recordDate = new Date(record.month);
        return (
          recordDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
          recordDate.getUTCMonth() === currentDate.getUTCMonth()
        );
      });

      if (matchingRecord) {
        result.push(matchingRecord.amount);
      } else {
        result.push(0);
      }

      currentDate.setUTCMonth(currentDate.getUTCMonth() + 1);
    }

    return result;
  };

  const resetSelectedIndexes = () => {
    setSelectedIndexCogs([]);
    setSelectedIndexOperating([]);
    setSelectedIndexFinance([]);
    setSelectedIndexOther([]);
  };

  const sortCategoriesExpense = items => {
    const defaultItems = items
      .filter(item => item.default_value === true)
      .sort((a, b) => a.expense_heads_id - b.expense_heads_id);

    const titleCount = {};

    defaultItems.forEach(item => {
      const title = item._expense_heads.title;

      if (titleCount[title]) {
        titleCount[title]++;
        item._expense_heads.title = `${title} ${titleCount[title]}`;
      } else {
        titleCount[title] = 1;
      }
    });

    const customItems = items.filter(item => item.custom_value === true);

    const otherItems = items.filter(
      item => !item.default_value && !item.custom_value
    );

    return [...defaultItems, ...customItems, ...otherItems];
  };

  const totalCashPaid = (array1, array2, array3) => {
    const length = array1.length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      result[i] = array1[i] + array2[i] + array3[i];
    }

    return result;
  };

  const totalForCategory = arrays => {
    let result = [];

    for (let i = 0; i < arrays.length; i++) {
      let sum = 0;
      for (let j = 0; j < arrays[i].length; j++) {
        sum += arrays[i][j];
      }
      result.push(sum);
    }

    return result;
  };

  const totalForMonth = arrays => {
    const length = arrays[0].length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      for (let j = 0; j < arrays.length; j++) {
        result[i] += arrays[j][i];
      }
    }

    let totalSum = result.reduce((acc, val) => acc + val, 0);

    result.push(totalSum);

    return result;
  };

  const updateStartingBalanceWithExpenseChange = (
    startingBalance,
    oldExpense,
    newExpense
  ) => {
    const updatedStartingBalance = [...startingBalance];

    for (let i = 0; i < oldExpense.length; i++) {
      const difference = newExpense[i] - oldExpense[i];
      if (difference !== 0) {
        for (let j = i + 1; j < updatedStartingBalance.length; j++) {
          updatedStartingBalance[j] -= difference;
        }
        break;
      }
    }

    return updatedStartingBalance;
  };
  const defaultPostExpensesPOST = DefaultApi.usePostExpensesPOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                flex: { minWidth: Breakpoints.Laptop, value: 1 },
                flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
                maxHeight: {
                  minWidth: Breakpoints.Laptop,
                  value: dimensions.height,
                },
              },
              dimensions.width
            )}
          >
            <SideMenuBlock screen={'expenses'} />
            {/* Exoenses Form Screen */}
            <View
              style={StyleSheet.applyWidth(
                { flex: { minWidth: Breakpoints.Laptop, value: 1 } },
                dimensions.width
              )}
            >
              {/* Header */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    marginBottom: { minWidth: Breakpoints.Laptop, value: 100 },
                  },
                  dimensions.width
                )}
              >
                <LinearGradient
                  color1={theme.colors.branding.primary}
                  color2={theme.colors.branding.secondary}
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)[
                    'Header Linear Gradient'
                  ].props}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.LinearGradientStyles(theme)[
                      'Header Linear Gradient'
                    ].style,
                    dimensions.width
                  )}
                >
                  {/* Left */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        paddingLeft: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  />
                  {/* Middle */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 3 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Header'].style,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 22,
                            },
                            paddingBottom: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                            paddingTop: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Forecasted Expenses'}
                    </Text>
                  </View>
                  {/* Right */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-end',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <IconButton
                      onPress={() => {
                        try {
                          navigation.navigate('BestPracticesScreen');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      color={palettes.Brand.White}
                      icon={'Entypo/help-with-circle'}
                      size={24}
                      style={StyleSheet.applyWidth(
                        { right: { minWidth: Breakpoints.Laptop, value: 24 } },
                        dimensions.width
                      )}
                    />
                  </View>
                </LinearGradient>
              </View>
              <>
                {isFetching ? null : (
                  <DefaultApi.FetchGetExpenseHeadsGET
                    handlers={{
                      onData: fetchData => {
                        const handler = async () => {
                          try {
                            if (reFetch) {
                              return;
                            }
                            setIsLoading(true);
                            resetSelectedIndexes();
                            const defaultHead = (
                              await DefaultApi.allExpensesGET(Constants)
                            )?.json;
                            setDefaultExpenseCategories(defaultHead);

                            const valueJyLu5Y6x = fetchData?.cogs;
                            const categoriesPaymentRes = valueJyLu5Y6x;
                            setAllCategoriesPayment(valueJyLu5Y6x);
                            const valueUIJcpaEa = sortCategoriesExpense(
                              (fetchData?.operating_expenses).concat(
                                fetchData?.custom_operating_expenses
                              )
                            );
                            const categoriesOperatingRes = valueUIJcpaEa;
                            setAllCategoriesOperating(valueUIJcpaEa);
                            const value1tmvfZSL = sortCategoriesExpense(
                              (fetchData?.finance_expenses).concat(
                                fetchData?.custom_finance_expenses
                              )
                            );
                            const categoriesFinanceRes = value1tmvfZSL;
                            setAllCategoriesFinance(value1tmvfZSL);
                            const valuevROQo2N7 = sortCategoriesExpense(
                              (fetchData?.other_operating_data).concat(
                                fetchData?.custom_other_operating_data
                              )
                            );
                            const categoriesOtherRes = valuevROQo2N7;
                            setAllCategoriesOther(valuevROQo2N7);
                            const resExpense = (
                              await DefaultApi.getExpenseGET(Constants, {
                                starting_date: newFormatDate(
                                  Constants['STARTING_DATE'],
                                  'get'
                                ),
                              })
                            )?.json;
                            const total_income = setGlobalVariableValue({
                              key: 'TOTAL_INCOME',
                              value: getMonthlyIncome(
                                resExpense?.total_income,
                                Constants['STARTING_DATE']
                              ),
                            });

                            const valueYnCzCKF7 = [].concat(
                              (resExpense?.cogs?.default).concat(
                                resExpense?.cogs?.custom
                              )
                            );
                            const monthlyPaymentExpense = valueYnCzCKF7;
                            setPaymentData(valueYnCzCKF7);
                            const valuecN8QpEvC = [].concat(
                              (resExpense?.operating_expenses?.default).concat(
                                resExpense?.operating_expenses?.custom
                              )
                            );
                            const monthlyOperatingExpense = valuecN8QpEvC;
                            setOperatingData(valuecN8QpEvC);
                            const valueYfsRs3JR = [].concat(
                              (resExpense?.finance_expenses?.default).concat(
                                resExpense?.finance_expenses?.custom
                              )
                            );
                            const monthlyFinanceExpense = valueYfsRs3JR;
                            setFinanceData(valueYfsRs3JR);
                            const valueachJmQyT = [].concat(
                              (resExpense?.other_operating_data?.default).concat(
                                resExpense?.other_operating_data?.custom
                              )
                            );
                            const monthlyOtherExpense = valueachJmQyT;
                            setOtherData(valueachJmQyT);
                            if (
                              resExpense?.message ||
                              resExpense?.operating_expense?.default?.length ===
                                0
                            ) {
                              const initDataOpertaing = (() => {
                                if (numberInputsOperating?.length === 0) {
                                  return initTableRows(
                                    categoriesOperatingRes?.length,
                                    12
                                  );
                                }
                              })();
                              if (numberInputsOperating?.length === 0) {
                                setNumberInputsOperating(initDataOpertaing);
                              }
                              const initDataFinance = (() => {
                                if (numberInputsFinance?.length === 0) {
                                  return initTableRows(
                                    categoriesFinanceRes?.length,
                                    12
                                  );
                                }
                              })();
                              if (numberInputsFinance?.length === 0) {
                                setNumberInputsFinance(initDataFinance);
                              }
                              const initDataOther = (() => {
                                if (numberInputsOther?.length === 0) {
                                  return initTableRows(
                                    categoriesOtherRes?.length,
                                    12
                                  );
                                }
                              })();
                              if (numberInputsOther?.length === 0) {
                                setNumberInputsOther(initDataOther);
                              }
                              const initDataPayment = (() => {
                                if (numberInputsPaymentForCost?.length === 0) {
                                  return initTableRows(1, 12);
                                }
                              })();
                              if (numberInputsPaymentForCost?.length === 0) {
                                setNumberInputsPaymentForCost(initDataPayment);
                              }
                            } else {
                              const valuen8zGoPW7 = prefillNumberExpense(
                                monthlyPaymentExpense,
                                categoriesPaymentRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niPaymentRes = valuen8zGoPW7;
                              setNumberInputsPaymentForCost(valuen8zGoPW7);
                              const valuespNfSCQs = prefillNumberExpense(
                                monthlyOperatingExpense,
                                categoriesOperatingRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niOperatingRes = valuespNfSCQs;
                              setNumberInputsOperating(valuespNfSCQs);
                              const valuebzcBWRLV = prefillNumberExpense(
                                monthlyFinanceExpense,
                                categoriesFinanceRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niFinanceRes = valuebzcBWRLV;
                              setNumberInputsFinance(valuebzcBWRLV);
                              const valueMANClFCS = prefillNumberExpense(
                                monthlyOtherExpense,
                                categoriesOtherRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niOtherRes = valueMANClFCS;
                              setNumberInputsOther(valueMANClFCS);
                              const valueaC1SEooo = totalForMonth(niPaymentRes);
                              const paymentPerMonth = valueaC1SEooo;
                              setTotalPaymentForCostPerMonth(valueaC1SEooo);
                              setTotalPaymentForCostPerCetagory(
                                totalForCategory(niPaymentRes)
                              );

                              const valueSQI0QtUS =
                                totalForMonth(niOperatingRes);
                              const operatingPerMonth = valueSQI0QtUS;
                              setTotalOperatingPerMonth(valueSQI0QtUS);
                              setTotalOperatingPerCategory(
                                totalForCategory(niOperatingRes)
                              );

                              const valueL1l6X3fh =
                                totalForCategory(niFinanceRes);
                              const financePerMonth = valueL1l6X3fh;
                              setTotalFinancePerCategory(valueL1l6X3fh);
                              setTotalFinancePerMonth(
                                totalForMonth(niFinanceRes)
                              );
                              setTotalOtherPerCategory(
                                totalForCategory(niOtherRes)
                              );

                              const valuefWCIdE5M = (() => {
                                const e = totalCashPaid(
                                  totalForMonth(niPaymentRes),
                                  totalForMonth(niOperatingRes),
                                  totalForMonth(niFinanceRes)
                                );
                                console.log('total cash paid:', e);
                                return e;
                              })();
                              const total_cash_paid = valuefWCIdE5M;
                              setTotalCashPaidOut(valuefWCIdE5M);
                              /* hidden 'Set Variable' action */
                              setMonthlyStartingBalance(
                                (() => {
                                  const e = pullStartingBalance(
                                    resExpense?.cash_at_hand,
                                    Constants['STARTING_DATE']
                                  );
                                  console.log('STARTING BALANCE:', e);
                                  return e;
                                })()
                              );
                            }

                            setReFetch(true);
                            setIsLoading(false);
                          } catch (err) {
                            console.error(err);
                          }
                        };
                        handler();
                      },
                    }}
                  >
                    {({ loading, error, data, refetchGetExpenseHeads }) => {
                      const fetchData = data?.json;
                      if (loading) {
                        return (
                          <>
                            {/* isLoading View */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  bottom: {
                                    minWidth: Breakpoints.Desktop,
                                    value: 0,
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 20,
                                  },
                                  height: {
                                    minWidth: Breakpoints.Laptop,
                                    value: dimensions.height,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  left: {
                                    minWidth: Breakpoints.Desktop,
                                    value: 0,
                                  },
                                  position: [
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: 'absolute',
                                    },
                                    {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'absolute',
                                    },
                                  ],
                                  right: {
                                    minWidth: Breakpoints.Desktop,
                                    value: 0,
                                  },
                                  top: {
                                    minWidth: Breakpoints.Desktop,
                                    value: 0,
                                  },
                                  width: {
                                    minWidth: Breakpoints.Laptop,
                                    value: '100%',
                                  },
                                },
                                dimensions.width
                              )}
                            />
                          </>
                        );
                      }

                      if (error || data?.status < 200 || data?.status >= 300) {
                        return <ActivityIndicator />;
                      }

                      return (
                        <>
                          <>
                            {isLoading ? null : (
                              <SimpleStyleScrollView
                                bounces={true}
                                keyboardShouldPersistTaps={'never'}
                                nestedScrollEnabled={false}
                                showsHorizontalScrollIndicator={true}
                                showsVerticalScrollIndicator={true}
                                horizontal={true}
                              >
                                {/* Table */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.Background
                                          : palettes.Brand.White,
                                      },
                                      flex: {
                                        minWidth: Breakpoints.BigScreen,
                                        value: 1,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Header */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        height: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 25,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Month */}
                                    <LinearGradient
                                      color1={theme.colors.branding.primary}
                                      color2={theme.colors.branding.secondary}
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    />
                                    {/* Months List */}
                                    <SimpleStyleFlatList
                                      data={generateDates(
                                        Constants['STARTING_DATE']
                                      )}
                                      decelerationRate={'normal'}
                                      inverted={false}
                                      keyExtractor={(monthsListData, index) =>
                                        monthsListData?.id ??
                                        monthsListData?.uuid ??
                                        index?.toString() ??
                                        JSON.stringify(monthsListData)
                                      }
                                      keyboardShouldPersistTaps={'never'}
                                      listKey={'Jhy9LQbU'}
                                      nestedScrollEnabled={false}
                                      numColumns={1}
                                      onEndReachedThreshold={0.5}
                                      pagingEnabled={false}
                                      renderItem={({ item, index }) => {
                                        const monthsListData = item;
                                        return (
                                          <>
                                            {/* Months Gradient */}
                                            <LinearGradient
                                              color1={
                                                theme.colors.branding.primary
                                              }
                                              color2={
                                                theme.colors.branding.secondary
                                              }
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 75,
                                                    },
                                                    width: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: cellWidth(),
                                                      },
                                                    ],
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {/* Months Text */}
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {monthsListData}
                                              </Text>
                                            </LinearGradient>
                                          </>
                                        );
                                      }}
                                      showsVerticalScrollIndicator={true}
                                      snapToAlignment={'start'}
                                      horizontal={true}
                                      scrollEnabled={false}
                                      showsHorizontalScrollIndicator={false}
                                    />
                                    {/* Total */}
                                    <LinearGradient
                                      color1={theme.colors.branding.primary}
                                      color2={theme.colors.branding.secondary}
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 75,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: cellWidth(),
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Total Text */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Total'}
                                      </Text>
                                    </LinearGradient>
                                    {/* % Of Income Gradient */}
                                    <LinearGradient
                                      color1={theme.colors.branding.primary}
                                      color2={theme.colors.branding.secondary}
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 75,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: cellWidth(),
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* % Of Income Text */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'% Of Income'}
                                      </Text>
                                    </LinearGradient>
                                    {/* Benchmarks */}
                                    <LinearGradient
                                      color1={theme.colors.branding.primary}
                                      color2={theme.colors.branding.secondary}
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 215,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 215,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 215,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Benchmarks */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Benchmarks'}
                                      </Text>
                                    </LinearGradient>
                                  </View>

                                  <SimpleStyleScrollView
                                    bounces={true}
                                    horizontal={false}
                                    keyboardShouldPersistTaps={'never'}
                                    nestedScrollEnabled={false}
                                    showsHorizontalScrollIndicator={true}
                                    showsVerticalScrollIndicator={true}
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Table Rows */}
                                    <View>
                                      {/* Payment for Cost Purchases (COGS) */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Catgories List */}
                                        <SimpleStyleFlatList
                                          data={allCategoriesPayment}
                                          decelerationRate={'normal'}
                                          horizontal={false}
                                          inverted={false}
                                          keyExtractor={(
                                            catgoriesListData,
                                            index
                                          ) =>
                                            catgoriesListData?.id ??
                                            catgoriesListData?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(catgoriesListData)
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'ZVBfHNKe'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const catgoriesListData = item;
                                            return (
                                              <View
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    flexDirection: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'row',
                                                    },
                                                  },
                                                  dimensions.width
                                                )}
                                              >
                                                <LinearGradient
                                                  endY={100}
                                                  color1={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Light'
                                                        ]) ??
                                                    palettes.App[
                                                      'Gray Linear Light'
                                                    ]
                                                  }
                                                  color2={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Dark'
                                                        ]) ??
                                                    palettes.App[
                                                      'Gray Linear Dark'
                                                    ]
                                                  }
                                                  endX={0}
                                                  startX={0}
                                                  startY={0}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      alignItems: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          palettes.Brand.Black,
                                                      },
                                                      borderLeftWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      maxHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      maxWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                      minHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 4,
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Categories Text */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                          paddingRight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 4,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {
                                                      catgoriesListData
                                                        ?._expense_heads?.title
                                                    }
                                                  </Text>
                                                </LinearGradient>
                                                {/* Payments for Cost Purchases List */}
                                                <SimpleStyleFlatList
                                                  data={[
                                                    0, 0, 0, 0, 0, 0, 0, 0, 0,
                                                    0, 0, 0,
                                                  ]}
                                                  decelerationRate={'normal'}
                                                  inverted={false}
                                                  keyExtractor={(
                                                    paymentsForCostPurchasesListData,
                                                    index
                                                  ) =>
                                                    paymentsForCostPurchasesListData?.id ??
                                                    paymentsForCostPurchasesListData?.uuid ??
                                                    index?.toString() ??
                                                    JSON.stringify(
                                                      paymentsForCostPurchasesListData
                                                    )
                                                  }
                                                  keyboardShouldPersistTaps={
                                                    'never'
                                                  }
                                                  listKey={JSON.stringify([
                                                    0, 0, 0, 0, 0, 0, 0, 0, 0,
                                                    0, 0, 0,
                                                  ])}
                                                  nestedScrollEnabled={false}
                                                  numColumns={1}
                                                  onEndReachedThreshold={0.5}
                                                  pagingEnabled={false}
                                                  renderItem={({
                                                    item,
                                                    index,
                                                  }) => {
                                                    const paymentsForCostPurchasesListData =
                                                      item;
                                                    return (
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        color1={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.Brand
                                                                .Background
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          'theme.colors["Inner Gradient"]'
                                                        }
                                                        color2={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        }
                                                        color3={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.Brand
                                                                .Background
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          'theme.colors["Inner Gradient"]'
                                                        }
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .Black,
                                                            },
                                                            borderRightWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  cellWidth(),
                                                              },
                                                            ],
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        <NumberInput
                                                          changeTextDelay={500}
                                                          onBlur={() => {
                                                            const numberInputValue =
                                                              undefined;
                                                            try {
                                                              setSelectedIndexCogs(
                                                                addOrRemove(
                                                                  selectedIndexCogs,
                                                                  index,
                                                                  0
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          onChangeText={newNumberInputValue => {
                                                            const numberInputValue =
                                                              newNumberInputValue;
                                                            try {
                                                              updateTableRows(
                                                                index,
                                                                0,
                                                                newNumberInputValue,
                                                                numberInputsPaymentForCost
                                                              );
                                                              setTotalPaymentForCostPerCetagory(
                                                                totalForCategory(
                                                                  numberInputsPaymentForCost
                                                                )
                                                              );
                                                              setTotalPaymentForCostPerMonth(
                                                                totalForMonth(
                                                                  numberInputsPaymentForCost
                                                                )
                                                              );

                                                              const valueRvzpopWU =
                                                                totalCashPaid(
                                                                  totalForMonth(
                                                                    numberInputsPaymentForCost
                                                                  ),
                                                                  totalOperatingPerMonth,
                                                                  totalFinancePerMonth
                                                                );
                                                              const new_cash_paid_out =
                                                                valueRvzpopWU;
                                                              setTotalCashPaidOut(
                                                                valueRvzpopWU
                                                              );
                                                              setMonthlyStartingBalance(
                                                                updateStartingBalanceWithExpenseChange(
                                                                  monthlyStartingBalance,
                                                                  totalCashPaidOut.slice(
                                                                    0,
                                                                    12
                                                                  ),
                                                                  new_cash_paid_out.slice(
                                                                    0,
                                                                    12
                                                                  )
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          onFocus={() => {
                                                            const numberInputValue =
                                                              undefined;
                                                            try {
                                                              setSelectedIndexCogs(
                                                                addOrRemove(
                                                                  selectedIndexCogs,
                                                                  index,
                                                                  0
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          webShowOutline={true}
                                                          {...GlobalStyles.NumberInputStyles(
                                                            theme
                                                          )[
                                                            'Table Number Input'
                                                          ].props}
                                                          defaultValue={getInitValue(
                                                            numberInputsPaymentForCost,
                                                            0,
                                                            index
                                                          )}
                                                          placeholder={''}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.NumberInputStyles(
                                                                theme
                                                              )[
                                                                'Table Number Input'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    selectedIndexCogs.includes(
                                                                      findColumnRowNumber(
                                                                        index,
                                                                        0
                                                                      )
                                                                    )
                                                                      ? Constants[
                                                                          'SWITCH_SCREEN_MODE'
                                                                        ]
                                                                        ? palettes
                                                                            .Brand
                                                                            .Black
                                                                        : palettes
                                                                            .Brand
                                                                            .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Transparent,
                                                                },
                                                                textAlign: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'right',
                                                                },
                                                                zIndex: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        />
                                                        {/* Format View */}
                                                        <>
                                                          {selectedIndexCogs.includes(
                                                            findColumnRowNumber(
                                                              index,
                                                              0
                                                            )
                                                          ) ? null : (
                                                            <View
                                                              style={StyleSheet.applyWidth(
                                                                {
                                                                  alignItems: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'center',
                                                                  },
                                                                  flexDirection:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'row',
                                                                    },
                                                                  justifyContent:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'space-between',
                                                                    },
                                                                  paddingLeft: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 4,
                                                                  },
                                                                  paddingRight:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 4,
                                                                    },
                                                                  position: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'absolute',
                                                                  },
                                                                  width: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      '100%',
                                                                  },
                                                                  zIndex: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 0,
                                                                  },
                                                                },
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {/* $ */}
                                                              <Text
                                                                accessible={
                                                                  true
                                                                }
                                                                selectable={
                                                                  false
                                                                }
                                                                {...GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Text'].props}
                                                                style={StyleSheet.applyWidth(
                                                                  StyleSheet.compose(
                                                                    GlobalStyles.TextStyles(
                                                                      theme
                                                                    )['Text']
                                                                      .style,
                                                                    {
                                                                      color: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                            ? palettes
                                                                                .Brand
                                                                                .Black
                                                                            : palettes
                                                                                .Brand
                                                                                .White,
                                                                      },
                                                                      fontFamily:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'OpenSans_600SemiBold',
                                                                        },
                                                                      fontSize:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value: 10,
                                                                        },
                                                                    }
                                                                  ),
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {'$'}
                                                              </Text>
                                                              {/* Number Value */}
                                                              <Text
                                                                accessible={
                                                                  true
                                                                }
                                                                selectable={
                                                                  false
                                                                }
                                                                {...GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Text'].props}
                                                                style={StyleSheet.applyWidth(
                                                                  StyleSheet.compose(
                                                                    GlobalStyles.TextStyles(
                                                                      theme
                                                                    )['Text']
                                                                      .style,
                                                                    {
                                                                      color: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                            ? palettes
                                                                                .Brand
                                                                                .Black
                                                                            : palettes
                                                                                .Brand
                                                                                .White,
                                                                      },
                                                                      fontFamily:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'OpenSans_600SemiBold',
                                                                        },
                                                                      fontSize:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value: 10,
                                                                        },
                                                                    }
                                                                  ),
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {formatNumber(
                                                                  getInitValue(
                                                                    numberInputsPaymentForCost,
                                                                    0,
                                                                    index
                                                                  )
                                                                )}
                                                              </Text>
                                                            </View>
                                                          )}
                                                        </>
                                                      </LinearGradient>
                                                    );
                                                  }}
                                                  showsHorizontalScrollIndicator={
                                                    true
                                                  }
                                                  showsVerticalScrollIndicator={
                                                    true
                                                  }
                                                  snapToAlignment={'start'}
                                                  horizontal={true}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      flex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                />
                                              </View>
                                            );
                                          }}
                                          showsHorizontalScrollIndicator={true}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                        />
                                        <SimpleStyleFlatList
                                          data={totalPaymentForCostPerCetagory}
                                          decelerationRate={'normal'}
                                          horizontal={false}
                                          inverted={false}
                                          keyExtractor={(listData, index) =>
                                            listData?.id ??
                                            listData?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(listData)
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'4fSB87Gf'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const listData = item;
                                            return (
                                              <>
                                                {/* Inner Linear Gradient */}
                                                <LinearGradient
                                                  endY={100}
                                                  startX={0}
                                                  startY={0}
                                                  color1={
                                                    checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Light'
                                                        ]
                                                  }
                                                  color2={
                                                    checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Dark'
                                                        ]
                                                  }
                                                  endX={0}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      alignItems: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      maxHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      minHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      width: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.BigScreen,
                                                          value: cellWidth(),
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: cellWidth(),
                                                        },
                                                      ],
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Total Value */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ]
                                                              ? palettes.Brand
                                                                  .Black
                                                              : palettes.Brand
                                                                  .White,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {'$'}
                                                    {formatNumber(listData)}
                                                  </Text>
                                                </LinearGradient>
                                              </>
                                            );
                                          }}
                                          showsHorizontalScrollIndicator={true}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                        />
                                        {/* Inner Linear Gradient 2 */}
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? palettes.App[
                                                  'Gray Linear Light'
                                                ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? palettes.App['Gray Linear Dark']
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={0}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              borderRightWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              minWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 75,
                                              },
                                              width: [
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 75,
                                                },
                                                {
                                                  minWidth:
                                                    Breakpoints.BigScreen,
                                                  value: cellWidth(),
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: cellWidth(),
                                                },
                                              ],
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* %Of Income */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: Constants[
                                                      'SWITCH_SCREEN_MODE'
                                                    ]
                                                      ? palettes.Brand.Black
                                                      : palettes.Brand.White,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {calculatePercentIncome(
                                              Constants['TOTAL_INCOME'],
                                              totalPaymentForCostPerCetagory
                                            )}
                                            {'%'}
                                          </Text>
                                        </LinearGradient>
                                        {/* Inner Linear Gradient 3 */}
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          color1={
                                            checkScreenMode(Variables)
                                              ? palettes.App[
                                                  'Gray Linear Light'
                                                ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]
                                          }
                                          color2={
                                            checkScreenMode(Variables)
                                              ? palettes.App['Gray Linear Dark']
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]
                                          }
                                          endX={0}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              maxWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 200,
                                              },
                                              minWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 200,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 200,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Benchmark */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text White'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text White'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: Constants[
                                                      'SWITCH_SCREEN_MODE'
                                                    ]
                                                      ? palettes.Brand.Black
                                                      : palettes.Brand.White,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {
                                              (
                                                fetchData?.cogs &&
                                                (fetchData?.cogs)[0]
                                              )?._expense_heads?.benchmarks
                                            }
                                          </Text>
                                        </LinearGradient>
                                      </View>
                                      {/* Operating Expenses */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'flex-end',
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Header View */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 50,
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'flex-end',
                                              },
                                              padding: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 4,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Header */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Header'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Header'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black,
                                                  },
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_300Light',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 18,
                                                  },
                                                  textAlign: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'right',
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Operating Expenses'}
                                          </Text>
                                        </View>
                                        {/* Row */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Categories List */}
                                          <SimpleStyleFlatList
                                            data={allCategoriesOperating}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(
                                              categoriesListData,
                                              index
                                            ) =>
                                              categoriesListData?.id ??
                                              categoriesListData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(categoriesListData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'0493PFOa'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const categoriesListData = item;
                                              return (
                                                <View
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      flexDirection: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'row',
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Categories Linear Gradient */}
                                                  <LinearGradient
                                                    endY={100}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    startX={0}
                                                    startY={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .Black,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderTopWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            categoriesListData?.default_value ||
                                                            categoriesListData?.custom_value
                                                              ? 'flex-end'
                                                              : 'space-between',
                                                        },
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        maxWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Remove Button */}
                                                    <>
                                                      {categoriesListData?.default_value ||
                                                      categoriesListData?.custom_value ? null : (
                                                        <IconButton
                                                          onPress={() => {
                                                            try {
                                                              setAllCategoriesOperating(
                                                                removeFromCategories(
                                                                  allCategoriesOperating,
                                                                  index
                                                                )
                                                              );
                                                              setNumberInputsOperating(
                                                                removeFromNumberInputs(
                                                                  index,
                                                                  numberInputsOperating
                                                                )
                                                              );
                                                              setTotalOperatingPerCategory(
                                                                totalForCategory(
                                                                  numberInputsOperating
                                                                )
                                                              );
                                                              setTotalOperatingPerMonth(
                                                                totalForMonth(
                                                                  numberInputsOperating
                                                                )
                                                              );
                                                              setReRender(
                                                                !reRender
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          color={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black) ??
                                                            palettes.Brand.White
                                                          }
                                                          icon={
                                                            'AntDesign/minus'
                                                          }
                                                          size={16}
                                                        />
                                                      )}
                                                    </>
                                                    {/* Categories Text */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                            paddingRight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 4,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {categoriesListData?.custom_value ===
                                                      true
                                                        ? categoriesListData?.title
                                                        : categoriesListData
                                                            ?._expense_heads
                                                            ?.title}
                                                    </Text>
                                                  </LinearGradient>
                                                  {/* Categories Expenses per month */}
                                                  <SimpleStyleFlatList
                                                    data={[
                                                      1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                      10, 11, 12,
                                                    ]}
                                                    decelerationRate={'normal'}
                                                    inverted={false}
                                                    keyExtractor={(
                                                      categoriesExpensesPerMonthData,
                                                      index
                                                    ) =>
                                                      categoriesExpensesPerMonthData?.id ??
                                                      categoriesExpensesPerMonthData?.uuid ??
                                                      index?.toString() ??
                                                      JSON.stringify(
                                                        categoriesExpensesPerMonthData
                                                      )
                                                    }
                                                    keyboardShouldPersistTaps={
                                                      'never'
                                                    }
                                                    listKey={JSON.stringify([
                                                      1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                      10, 11, 12,
                                                    ])}
                                                    nestedScrollEnabled={false}
                                                    numColumns={1}
                                                    onEndReachedThreshold={0.5}
                                                    pagingEnabled={false}
                                                    renderItem={({
                                                      item,
                                                      index,
                                                    }) => {
                                                      const categoriesExpensesPerMonthData =
                                                        item;
                                                      return (
                                                        <LinearGradient
                                                          endY={100}
                                                          startX={0}
                                                          startY={0}
                                                          {...GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Inner Gradient']
                                                            .props}
                                                          color1={
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .Background
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]
                                                          }
                                                          color2={
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Dark'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Light'
                                                                ]
                                                          }
                                                          color3={
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .Background
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]
                                                          }
                                                          endX={0}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.LinearGradientStyles(
                                                                theme
                                                              )[
                                                                'Inner Gradient'
                                                              ].style,
                                                              {
                                                                maxWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: null,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.BigScreen,
                                                                  value:
                                                                    cellWidth(),
                                                                },
                                                                width: {
                                                                  minWidth:
                                                                    Breakpoints.BigScreen,
                                                                  value:
                                                                    cellWidth(),
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {/* Number Input 2 */}
                                                          <NumberInput
                                                            changeTextDelay={
                                                              500
                                                            }
                                                            onBlur={() => {
                                                              const numberInputValue =
                                                                undefined;
                                                              try {
                                                                setSelectedIndexOperating(
                                                                  addOrRemove(
                                                                    selectedIndexOperating,
                                                                    index,
                                                                    findIndexExpense(
                                                                      operatingData?.length ===
                                                                        0
                                                                        ? allCategoriesOperating
                                                                        : sortCategoriesExpense(
                                                                            allCategoriesOperating
                                                                          ),
                                                                      categoriesListData
                                                                    )
                                                                  )
                                                                );
                                                              } catch (err) {
                                                                console.error(
                                                                  err
                                                                );
                                                              }
                                                            }}
                                                            onChangeText={newNumberInput2Value => {
                                                              const numberInputValue =
                                                                newNumberInput2Value;
                                                              try {
                                                                updateTableRows(
                                                                  index,
                                                                  findIndexExpense(
                                                                    allCategoriesOperating,
                                                                    categoriesListData
                                                                  ),
                                                                  newNumberInput2Value >=
                                                                    0
                                                                    ? newNumberInput2Value
                                                                    : 0,
                                                                  numberInputsOperating
                                                                );
                                                                setTotalOperatingPerCategory(
                                                                  totalForCategory(
                                                                    numberInputsOperating
                                                                  )
                                                                );
                                                                setTotalOperatingPerMonth(
                                                                  totalForMonth(
                                                                    numberInputsOperating
                                                                  )
                                                                );

                                                                const valueCBN2SSb0 =
                                                                  totalCashPaid(
                                                                    totalPaymentForCostPerMonth,
                                                                    totalForMonth(
                                                                      numberInputsOperating
                                                                    ),
                                                                    totalFinancePerMonth
                                                                  );
                                                                const new_cash_paid_out =
                                                                  valueCBN2SSb0;
                                                                setTotalCashPaidOut(
                                                                  valueCBN2SSb0
                                                                );
                                                                setMonthlyStartingBalance(
                                                                  updateStartingBalanceWithExpenseChange(
                                                                    monthlyStartingBalance,
                                                                    totalCashPaidOut.slice(
                                                                      0,
                                                                      12
                                                                    ),
                                                                    new_cash_paid_out.slice(
                                                                      0,
                                                                      12
                                                                    )
                                                                  )
                                                                );
                                                              } catch (err) {
                                                                console.error(
                                                                  err
                                                                );
                                                              }
                                                            }}
                                                            onFocus={() => {
                                                              const numberInputValue =
                                                                undefined;
                                                              try {
                                                                setSelectedIndexOperating(
                                                                  addOrRemove(
                                                                    selectedIndexOperating,
                                                                    index,
                                                                    findIndexExpense(
                                                                      operatingData?.length ===
                                                                        0
                                                                        ? allCategoriesOperating
                                                                        : sortCategoriesExpense(
                                                                            allCategoriesOperating
                                                                          ),
                                                                      categoriesListData
                                                                    )
                                                                  )
                                                                );
                                                              } catch (err) {
                                                                console.error(
                                                                  err
                                                                );
                                                              }
                                                            }}
                                                            webShowOutline={
                                                              true
                                                            }
                                                            {...GlobalStyles.NumberInputStyles(
                                                              theme
                                                            )[
                                                              'Table Number Input'
                                                            ].props}
                                                            defaultValue={getInitValue(
                                                              numberInputsOperating,
                                                              findIndexExpense(
                                                                operatingData?.length ===
                                                                  0
                                                                  ? allCategoriesOperating
                                                                  : sortCategoriesExpense(
                                                                      allCategoriesOperating
                                                                    ),
                                                                categoriesListData
                                                              ),
                                                              index
                                                            )}
                                                            placeholder={''}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.NumberInputStyles(
                                                                  theme
                                                                )[
                                                                  'Table Number Input'
                                                                ].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      selectedIndexOperating.includes(
                                                                        findColumnRowNumber(
                                                                          index,
                                                                          findIndexExpense(
                                                                            operatingData?.length ===
                                                                              0
                                                                              ? allCategoriesOperating
                                                                              : sortCategoriesExpense(
                                                                                  allCategoriesOperating
                                                                                ),
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      )
                                                                        ? Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                          ? palettes
                                                                              .Brand
                                                                              .Black
                                                                          : palettes
                                                                              .Brand
                                                                              .White
                                                                        : palettes
                                                                            .Brand
                                                                            .Transparent,
                                                                  },
                                                                  textAlign: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'right',
                                                                  },
                                                                  zIndex: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          />
                                                          {/* Format View */}
                                                          <>
                                                            {selectedIndexOperating.includes(
                                                              findColumnRowNumber(
                                                                index,
                                                                findIndexExpense(
                                                                  operatingData?.length ===
                                                                    0
                                                                    ? allCategoriesOperating
                                                                    : sortCategoriesExpense(
                                                                        allCategoriesOperating
                                                                      ),
                                                                  categoriesListData
                                                                )
                                                              )
                                                            ) ? null : (
                                                              <View
                                                                style={StyleSheet.applyWidth(
                                                                  {
                                                                    alignItems:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    flexDirection:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'row',
                                                                      },
                                                                    justifyContent:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'space-between',
                                                                      },
                                                                    paddingLeft:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 4,
                                                                      },
                                                                    paddingRight:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 4,
                                                                      },
                                                                    position: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'absolute',
                                                                    },
                                                                    width: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        '100%',
                                                                    },
                                                                    zIndex: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 0,
                                                                    },
                                                                  },
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {/* $ */}
                                                                <Text
                                                                  accessible={
                                                                    true
                                                                  }
                                                                  selectable={
                                                                    false
                                                                  }
                                                                  {...GlobalStyles.TextStyles(
                                                                    theme
                                                                  )['Text']
                                                                    .props}
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.TextStyles(
                                                                        theme
                                                                      )['Text']
                                                                        .style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            Constants[
                                                                              'SWITCH_SCREEN_MODE'
                                                                            ]
                                                                              ? palettes
                                                                                  .Brand
                                                                                  .Black
                                                                              : palettes
                                                                                  .Brand
                                                                                  .White,
                                                                        },
                                                                        fontFamily:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'OpenSans_600SemiBold',
                                                                          },
                                                                        fontSize:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 10,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                >
                                                                  {'$'}
                                                                </Text>
                                                                {/* Number Value */}
                                                                <Text
                                                                  accessible={
                                                                    true
                                                                  }
                                                                  selectable={
                                                                    false
                                                                  }
                                                                  {...GlobalStyles.TextStyles(
                                                                    theme
                                                                  )['Text']
                                                                    .props}
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.TextStyles(
                                                                        theme
                                                                      )['Text']
                                                                        .style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            Constants[
                                                                              'SWITCH_SCREEN_MODE'
                                                                            ]
                                                                              ? palettes
                                                                                  .Brand
                                                                                  .Black
                                                                              : palettes
                                                                                  .Brand
                                                                                  .White,
                                                                        },
                                                                        fontFamily:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'OpenSans_600SemiBold',
                                                                          },
                                                                        fontSize:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 10,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                >
                                                                  {formatNumber(
                                                                    getInitValue(
                                                                      numberInputsOperating,
                                                                      findIndexExpense(
                                                                        operatingData?.length ===
                                                                          0
                                                                          ? allCategoriesOperating
                                                                          : sortCategoriesExpense(
                                                                              allCategoriesOperating
                                                                            ),
                                                                        categoriesListData
                                                                      ),
                                                                      index
                                                                    )
                                                                  )}
                                                                </Text>
                                                              </View>
                                                            )}
                                                          </>
                                                        </LinearGradient>
                                                      );
                                                    }}
                                                    showsHorizontalScrollIndicator={
                                                      true
                                                    }
                                                    showsVerticalScrollIndicator={
                                                      true
                                                    }
                                                    snapToAlignment={'start'}
                                                    extraData={reRender}
                                                    horizontal={true}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flex: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  />
                                                </View>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            extraData={reRender}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          />
                                          {/* Totals */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-start',
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Expense */}
                                            <SimpleStyleFlatList
                                              data={totalOperatingPerCategory}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                totalExpenseData,
                                                index
                                              ) =>
                                                totalExpenseData?.id ??
                                                totalExpenseData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(totalExpenseData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'eFTu83im'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalExpenseData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                cellWidth(),
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                cellWidth(),
                                                            },
                                                          ],
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$'}
                                                      {formatNumber(
                                                        totalExpenseData
                                                      )}
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                            {/* %Of Income */}
                                            <SimpleStyleFlatList
                                              data={calculatePercentIncome(
                                                Constants['TOTAL_INCOME'],
                                                totalOperatingPerCategory
                                              )}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                ofIncomeData,
                                                index
                                              ) =>
                                                ofIncomeData?.id ??
                                                ofIncomeData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(ofIncomeData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'tmgRdvfC'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const ofIncomeData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                cellWidth(),
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                cellWidth(),
                                                            },
                                                          ],
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {ofIncomeData}
                                                      {'%'}
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                            {/* Benchmarks */}
                                            <SimpleStyleFlatList
                                              data={
                                                operatingData?.length === 0
                                                  ? allCategoriesOperating
                                                  : sortCategoriesExpense(
                                                      allCategoriesOperating
                                                    )
                                              }
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                benchmarksData,
                                                index
                                              ) =>
                                                benchmarksData?.id ??
                                                benchmarksData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(benchmarksData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'KwhzG6o8'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const benchmarksData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {
                                                        benchmarksData
                                                          ?._expense_heads
                                                          ?.benchmarks
                                                      }
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                          </View>
                                        </View>
                                        {/* Additional Categories */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              maxHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              minHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Gray Linear Gradient */}
                                          <LinearGradient
                                            endY={100}
                                            color1={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]) ??
                                              palettes.App['Gray Linear Light']
                                            }
                                            color2={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]) ??
                                              palettes.App['Gray Linear Dark']
                                            }
                                            endX={0}
                                            startX={0}
                                            startY={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: [
                                                  {
                                                    minWidth:
                                                      Breakpoints.Desktop,
                                                    value: 'stretch',
                                                  },
                                                  {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'stretch',
                                                  },
                                                ],
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.Black,
                                                },
                                                borderLeftWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderRightWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'center',
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Remove Button */}
                                            <>
                                              {!toggleAddCategoryOperating ? null : (
                                                <IconButton
                                                  onPress={() => {
                                                    try {
                                                      setToggleAddCategoryOperating(
                                                        false
                                                      );
                                                      setToggleNewCategoryOperating(
                                                        false
                                                      );
                                                      setNewCategory('');
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  color={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black) ??
                                                    palettes.Brand.White
                                                  }
                                                  icon={'AntDesign/minus'}
                                                  size={16}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      left: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      position: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'absolute',
                                                      },
                                                      zIndex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 100,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                />
                                              )}
                                            </>
                                            {/* Custom Code Operating */}
                                            <>
                                              {!(
                                                toggleAddCategoryOperating &&
                                                !toggleNewCategoryOperating
                                              ) ? null : (
                                                <Utils.CustomCodeErrorBoundary>
                                                  <AdditionalCategoryExpenses.Dropdown
                                                    allCategories={
                                                      defaultExpenseCategories.operating_expenses
                                                    }
                                                    setToggleAddCategory={
                                                      setToggleAddCategoryOperating
                                                    }
                                                    setToggleNewCategory={
                                                      setToggleNewCategoryOperating
                                                    }
                                                    numberInputs={
                                                      numberInputsOperating
                                                    }
                                                    setNumberInputs={
                                                      setNumberInputsOperating
                                                    }
                                                    totalIncomePerCategories={
                                                      totalOperatingPerCategory
                                                    }
                                                    setTotalIncomePerCategories={
                                                      setTotalOperatingPerCategory
                                                    }
                                                    usersCategories={
                                                      allCategoriesOperating
                                                    }
                                                    setUsersCategories={
                                                      setAllCategoriesOperating
                                                    }
                                                    headType={'_expense_heads'}
                                                  />
                                                </Utils.CustomCodeErrorBoundary>
                                              )}
                                            </>
                                            <>
                                              {toggleAddCategoryOperating ||
                                              toggleNewCategoryOperating ? null : (
                                                <Button
                                                  accessible={true}
                                                  iconPosition={'left'}
                                                  onPress={() => {
                                                    try {
                                                      setToggleAddCategoryOperating(
                                                        true
                                                      );
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  {...GlobalStyles.ButtonStyles(
                                                    theme
                                                  )['Button'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.ButtonStyles(
                                                        theme
                                                      )['Button'].style,
                                                      {
                                                        backgroundColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'rgba(0, 0, 0, 0)',
                                                        },
                                                        color: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'System',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 16,
                                                        },
                                                        fontWeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '600',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                  title={'+'}
                                                />
                                              )}
                                            </>
                                            {/* Custom Category Input */}
                                            <>
                                              {!toggleNewCategoryOperating ? null : (
                                                <TextInput
                                                  autoCapitalize={'none'}
                                                  autoCorrect={true}
                                                  changeTextDelay={500}
                                                  onChangeText={newCustomCategoryInputValue => {
                                                    try {
                                                      setNewCategory(
                                                        newCustomCategoryInputValue
                                                      );
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  onSubmitEditing={() => {
                                                    try {
                                                      /* hidden 'Set Variable' action */
                                                      setAllCategoriesOperating(
                                                        customCategortyExpenses(
                                                          allCategoriesOperating,
                                                          newCategory
                                                        )
                                                      );
                                                      setReRender(!reRender);
                                                      setNumberInputsOperating(
                                                        addNewRow(
                                                          numberInputsOperating
                                                        )
                                                      );
                                                      setToggleNewCategoryOperating(
                                                        false
                                                      );
                                                      setToggleAddCategoryOperating(
                                                        false
                                                      );
                                                      setTotalOperatingPerCategory(
                                                        totalForCategory(
                                                          numberInputsOperating
                                                        )
                                                      );
                                                      setNewCategory('');
                                                      /* hidden 'Log to Console' action */
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  webShowOutline={true}
                                                  {...GlobalStyles.TextInputStyles(
                                                    theme
                                                  )['Text Input'].props}
                                                  autoFocus={true}
                                                  placeholder={
                                                    'Enter New Category'
                                                  }
                                                  placeholderTextColor={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black) ??
                                                    palettes.Brand.White
                                                  }
                                                  selectionColor={
                                                    'rgba(0, 0, 0, 0)'
                                                  }
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextInputStyles(
                                                        theme
                                                      )['Text Input'].style,
                                                      {
                                                        backgroundColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'rgba(0, 0, 0, 0)',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderRadius: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderTopWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        color: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                        ],
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'OpenSans_600SemiBold',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 10,
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                        textAlign: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'right',
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                  value={newCategory}
                                                />
                                              )}
                                            </>
                                          </LinearGradient>
                                        </View>
                                        {/* Total Expenses */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.White,
                                              },
                                              borderTopWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Total Operating Expenses */}
                                          <LinearGradient
                                            color1={
                                              theme.colors.branding.primary
                                            }
                                            color2={
                                              theme.colors.branding.secondary
                                            }
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  borderLeftWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  width: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Operating Expenses */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Total Operating Expenses'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Total List per month */}
                                          <SimpleStyleFlatList
                                            data={totalOperatingPerMonth.concat(
                                              [0, 0]
                                            )}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              totalListPerMonthData,
                                              index
                                            ) =>
                                              totalListPerMonthData?.id ??
                                              totalListPerMonthData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(
                                                totalListPerMonthData
                                              )
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'xfQb9p9H'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const totalListPerMonthData =
                                                item;
                                              return (
                                                <>
                                                  {/* Total List per month */}
                                                  <LinearGradient
                                                    color1={
                                                      theme.colors.branding
                                                        .primary
                                                    }
                                                    color2={
                                                      theme.colors.branding
                                                        .secondary
                                                    }
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderLeftWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          height: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 26,
                                                          },
                                                          maxHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 26,
                                                          },
                                                          minHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 26,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                index === 14
                                                                  ? 200
                                                                  : 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                index === 14
                                                                  ? 200
                                                                  : cellWidth(),
                                                            },
                                                          ],
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total List per month */}
                                                    <>
                                                      {!(index <= 12) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$'}
                                                          {formatNumber(
                                                            totalListPerMonthData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* %Income */}
                                                    <>
                                                      {!(
                                                        index === 13
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {calculatePercentIncome(
                                                            Constants[
                                                              'TOTAL_INCOME'
                                                            ],
                                                            totalOperatingPerMonth.slice(
                                                              12,
                                                              undefined
                                                            )
                                                          )}
                                                          {'%'}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* Benchmark */}
                                                    <>
                                                      {!(
                                                        index === 14
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'44-57%'}
                                                        </Text>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            extraData={reRender}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                      </View>
                                      {/* Finance Expenses */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'flex-end',
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Header View */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 50,
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'flex-end',
                                              },
                                              padding: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 4,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Header */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Header'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Header'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black,
                                                  },
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_300Light',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 18,
                                                  },
                                                  textAlign: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'right',
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Finance Expenses'}
                                          </Text>
                                        </View>
                                        {/* Rows */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Categories List */}
                                          <SimpleStyleFlatList
                                            data={allCategoriesFinance}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(
                                              categoriesListData,
                                              index
                                            ) =>
                                              categoriesListData?.id ??
                                              categoriesListData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(categoriesListData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'o3p1octZ'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const categoriesListData = item;
                                              return (
                                                <View
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      flexDirection: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'row',
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Categories Linear Gradient */}
                                                  <LinearGradient
                                                    endY={100}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    startX={0}
                                                    startY={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .Black,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderTopWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 'flex-end',
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              categoriesListData?.default_value ||
                                                              categoriesListData?.custom_value
                                                                ? 'flex-end'
                                                                : 'space-between',
                                                          },
                                                        ],
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        maxWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Remove Button */}
                                                    <>
                                                      {categoriesListData?.default_value ||
                                                      categoriesListData?.custom_value ? null : (
                                                        <IconButton
                                                          onPress={() => {
                                                            try {
                                                              setAllCategoriesFinance(
                                                                removeFromCategories(
                                                                  allCategoriesFinance,
                                                                  index
                                                                )
                                                              );
                                                              setNumberInputsFinance(
                                                                removeFromNumberInputs(
                                                                  index,
                                                                  numberInputsFinance
                                                                )
                                                              );
                                                              setTotalFinancePerCategory(
                                                                totalForCategory(
                                                                  numberInputsFinance
                                                                )
                                                              );
                                                              setTotalFinancePerMonth(
                                                                totalForMonth(
                                                                  numberInputsFinance
                                                                )
                                                              );
                                                              setReRender(
                                                                !reRender
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          color={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black) ??
                                                            palettes.Brand.White
                                                          }
                                                          icon={
                                                            'AntDesign/minus'
                                                          }
                                                          size={16}
                                                        />
                                                      )}
                                                    </>
                                                    {/* Categories Text */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                            paddingRight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 4,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {categoriesListData?.custom_value ===
                                                      true
                                                        ? categoriesListData?.title
                                                        : categoriesListData
                                                            ?._expense_heads
                                                            ?.title}
                                                    </Text>
                                                  </LinearGradient>
                                                  {/* Categories Expenses per month */}
                                                  <SimpleStyleFlatList
                                                    data={[
                                                      1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                      10, 11, 12,
                                                    ]}
                                                    decelerationRate={'normal'}
                                                    inverted={false}
                                                    keyExtractor={(
                                                      categoriesExpensesPerMonthData,
                                                      index
                                                    ) =>
                                                      categoriesExpensesPerMonthData?.id ??
                                                      categoriesExpensesPerMonthData?.uuid ??
                                                      index?.toString() ??
                                                      JSON.stringify(
                                                        categoriesExpensesPerMonthData
                                                      )
                                                    }
                                                    keyboardShouldPersistTaps={
                                                      'never'
                                                    }
                                                    listKey={JSON.stringify([
                                                      1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                      10, 11, 12,
                                                    ])}
                                                    nestedScrollEnabled={false}
                                                    numColumns={1}
                                                    onEndReachedThreshold={0.5}
                                                    pagingEnabled={false}
                                                    renderItem={({
                                                      item,
                                                      index,
                                                    }) => {
                                                      const categoriesExpensesPerMonthData =
                                                        item;
                                                      return (
                                                        <LinearGradient
                                                          endY={100}
                                                          startX={0}
                                                          startY={0}
                                                          {...GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Inner Gradient']
                                                            .props}
                                                          color1={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .Background
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]) ??
                                                            'theme.colors["Inner Gradient"]'
                                                          }
                                                          color2={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Dark'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Light'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          }
                                                          color3={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .Background
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]) ??
                                                            'theme.colors["Inner Gradient"]'
                                                          }
                                                          endX={0}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.LinearGradientStyles(
                                                                theme
                                                              )[
                                                                'Inner Gradient'
                                                              ].style,
                                                              {
                                                                maxWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: null,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.BigScreen,
                                                                  value:
                                                                    cellWidth(),
                                                                },
                                                                width: {
                                                                  minWidth:
                                                                    Breakpoints.BigScreen,
                                                                  value:
                                                                    cellWidth(),
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {/* Number Input 2 */}
                                                          <NumberInput
                                                            changeTextDelay={
                                                              500
                                                            }
                                                            onBlur={() => {
                                                              try {
                                                                setSelectedIndexFinance(
                                                                  addOrRemove(
                                                                    selectedIndexFinance,
                                                                    index,
                                                                    findIndexExpense(
                                                                      financeData?.length ===
                                                                        0
                                                                        ? allCategoriesFinance
                                                                        : sortCategoriesExpense(
                                                                            allCategoriesFinance
                                                                          ),
                                                                      categoriesListData
                                                                    )
                                                                  )
                                                                );
                                                              } catch (err) {
                                                                console.error(
                                                                  err
                                                                );
                                                              }
                                                            }}
                                                            onChangeText={newNumberInput2Value => {
                                                              try {
                                                                updateTableRows(
                                                                  index,
                                                                  findIndexExpense(
                                                                    allCategoriesFinance,
                                                                    categoriesListData
                                                                  ),
                                                                  newNumberInput2Value >=
                                                                    0
                                                                    ? newNumberInput2Value
                                                                    : 0,
                                                                  numberInputsFinance
                                                                );
                                                                setTotalFinancePerCategory(
                                                                  totalForCategory(
                                                                    numberInputsFinance
                                                                  )
                                                                );
                                                                setTotalFinancePerMonth(
                                                                  totalForMonth(
                                                                    numberInputsFinance
                                                                  )
                                                                );

                                                                const valuedbE7XJME =
                                                                  totalCashPaid(
                                                                    totalPaymentForCostPerMonth,
                                                                    totalOperatingPerMonth,
                                                                    totalForMonth(
                                                                      numberInputsFinance
                                                                    )
                                                                  );
                                                                const new_cash_paid_out =
                                                                  valuedbE7XJME;
                                                                setTotalCashPaidOut(
                                                                  valuedbE7XJME
                                                                );
                                                                setMonthlyStartingBalance(
                                                                  updateStartingBalanceWithExpenseChange(
                                                                    monthlyStartingBalance,
                                                                    totalCashPaidOut,
                                                                    new_cash_paid_out
                                                                  )
                                                                );
                                                              } catch (err) {
                                                                console.error(
                                                                  err
                                                                );
                                                              }
                                                            }}
                                                            onFocus={() => {
                                                              try {
                                                                setSelectedIndexFinance(
                                                                  addOrRemove(
                                                                    selectedIndexFinance,
                                                                    index,
                                                                    findIndexExpense(
                                                                      financeData?.length ===
                                                                        0
                                                                        ? allCategoriesFinance
                                                                        : sortCategoriesExpense(
                                                                            allCategoriesFinance
                                                                          ),
                                                                      categoriesListData
                                                                    )
                                                                  )
                                                                );
                                                              } catch (err) {
                                                                console.error(
                                                                  err
                                                                );
                                                              }
                                                            }}
                                                            webShowOutline={
                                                              true
                                                            }
                                                            {...GlobalStyles.NumberInputStyles(
                                                              theme
                                                            )[
                                                              'Table Number Input'
                                                            ].props}
                                                            defaultValue={getInitValue(
                                                              numberInputsFinance,
                                                              findIndexExpense(
                                                                financeData?.length ===
                                                                  0
                                                                  ? allCategoriesFinance
                                                                  : sortCategoriesExpense(
                                                                      allCategoriesFinance
                                                                    ),
                                                                categoriesListData
                                                              ),
                                                              index
                                                            )}
                                                            placeholder={''}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.NumberInputStyles(
                                                                  theme
                                                                )[
                                                                  'Table Number Input'
                                                                ].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      selectedIndexFinance.includes(
                                                                        findColumnRowNumber(
                                                                          index,
                                                                          findIndexExpense(
                                                                            financeData?.length ===
                                                                              0
                                                                              ? allCategoriesFinance
                                                                              : sortCategoriesExpense(
                                                                                  allCategoriesFinance
                                                                                ),
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      )
                                                                        ? Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                          ? palettes
                                                                              .Brand
                                                                              .Black
                                                                          : palettes
                                                                              .Brand
                                                                              .White
                                                                        : palettes
                                                                            .Brand
                                                                            .Transparent,
                                                                  },
                                                                  textAlign: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'right',
                                                                  },
                                                                  zIndex: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          />
                                                          {/* Format View */}
                                                          <>
                                                            {selectedIndexFinance.includes(
                                                              findColumnRowNumber(
                                                                index,
                                                                findIndexExpense(
                                                                  financeData?.length ===
                                                                    0
                                                                    ? allCategoriesFinance
                                                                    : sortCategoriesExpense(
                                                                        allCategoriesFinance
                                                                      ),
                                                                  categoriesListData
                                                                )
                                                              )
                                                            ) ? null : (
                                                              <View
                                                                style={StyleSheet.applyWidth(
                                                                  {
                                                                    alignItems:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    flexDirection:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'row',
                                                                      },
                                                                    justifyContent:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'space-between',
                                                                      },
                                                                    paddingLeft:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 4,
                                                                      },
                                                                    paddingRight:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 4,
                                                                      },
                                                                    position: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'absolute',
                                                                    },
                                                                    width: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        '100%',
                                                                    },
                                                                    zIndex: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 0,
                                                                    },
                                                                  },
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {/* $ */}
                                                                <Text
                                                                  accessible={
                                                                    true
                                                                  }
                                                                  selectable={
                                                                    false
                                                                  }
                                                                  {...GlobalStyles.TextStyles(
                                                                    theme
                                                                  )['Text']
                                                                    .props}
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.TextStyles(
                                                                        theme
                                                                      )['Text']
                                                                        .style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            Constants[
                                                                              'SWITCH_SCREEN_MODE'
                                                                            ]
                                                                              ? palettes
                                                                                  .Brand
                                                                                  .Black
                                                                              : palettes
                                                                                  .Brand
                                                                                  .White,
                                                                        },
                                                                        fontFamily:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'OpenSans_600SemiBold',
                                                                          },
                                                                        fontSize:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 10,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                >
                                                                  {'$'}
                                                                </Text>
                                                                {/* Number Value */}
                                                                <Text
                                                                  accessible={
                                                                    true
                                                                  }
                                                                  selectable={
                                                                    false
                                                                  }
                                                                  {...GlobalStyles.TextStyles(
                                                                    theme
                                                                  )['Text']
                                                                    .props}
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.TextStyles(
                                                                        theme
                                                                      )['Text']
                                                                        .style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            Constants[
                                                                              'SWITCH_SCREEN_MODE'
                                                                            ]
                                                                              ? palettes
                                                                                  .Brand
                                                                                  .Black
                                                                              : palettes
                                                                                  .Brand
                                                                                  .White,
                                                                        },
                                                                        fontFamily:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'OpenSans_600SemiBold',
                                                                          },
                                                                        fontSize:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 10,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                >
                                                                  {formatNumber(
                                                                    getInitValue(
                                                                      numberInputsFinance,
                                                                      findIndexExpense(
                                                                        financeData?.length ===
                                                                          0
                                                                          ? allCategoriesFinance
                                                                          : sortCategoriesExpense(
                                                                              allCategoriesFinance
                                                                            ),
                                                                        categoriesListData
                                                                      ),
                                                                      index
                                                                    )
                                                                  )}
                                                                </Text>
                                                              </View>
                                                            )}
                                                          </>
                                                        </LinearGradient>
                                                      );
                                                    }}
                                                    showsHorizontalScrollIndicator={
                                                      true
                                                    }
                                                    showsVerticalScrollIndicator={
                                                      true
                                                    }
                                                    snapToAlignment={'start'}
                                                    horizontal={true}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flex: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  />
                                                </View>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            extraData={reRender}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          />
                                          {/* Totals */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-start',
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Expense */}
                                            <SimpleStyleFlatList
                                              data={totalFinancePerCategory}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                totalExpenseData,
                                                index
                                              ) =>
                                                totalExpenseData?.id ??
                                                totalExpenseData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(totalExpenseData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'BM8tVUyq'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalExpenseData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$'}
                                                      {formatNumber(
                                                        totalExpenseData
                                                      )}
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                            {/* %Of Income */}
                                            <SimpleStyleFlatList
                                              data={calculatePercentIncome(
                                                Constants['TOTAL_INCOME'],
                                                totalFinancePerCategory
                                              )}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                ofIncomeData,
                                                index
                                              ) =>
                                                ofIncomeData?.id ??
                                                ofIncomeData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(ofIncomeData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'O5iOQcDY'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const ofIncomeData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {ofIncomeData}
                                                      {'%'}
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                            {/* Benchmarks */}
                                            <SimpleStyleFlatList
                                              data={allCategoriesFinance}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                benchmarksData,
                                                index
                                              ) =>
                                                benchmarksData?.id ??
                                                benchmarksData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(benchmarksData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'nBCdSdsL'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const benchmarksData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {
                                                        benchmarksData?.benchmarks
                                                      }
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                          </View>
                                        </View>
                                        {/* Additional Categories */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              maxHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              minHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Gray Linear Gradient */}
                                          <LinearGradient
                                            endY={100}
                                            color1={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]) ??
                                              palettes.App['Gray Linear Light']
                                            }
                                            color2={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]) ??
                                              palettes.App['Gray Linear Dark']
                                            }
                                            endX={0}
                                            startX={0}
                                            startY={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: [
                                                  {
                                                    minWidth:
                                                      Breakpoints.Desktop,
                                                    value: 'stretch',
                                                  },
                                                  {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'stretch',
                                                  },
                                                ],
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.Black,
                                                },
                                                borderLeftWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderRightWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'center',
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Remove Button */}
                                            <>
                                              {!toggleAddCategoryFinance ? null : (
                                                <IconButton
                                                  onPress={() => {
                                                    try {
                                                      setToggleAddCategoryFinance(
                                                        false
                                                      );
                                                      setToggleNewCategoryFinance(
                                                        false
                                                      );
                                                      setNewCategory('');
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  color={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black) ??
                                                    palettes.Brand.White
                                                  }
                                                  icon={'AntDesign/minus'}
                                                  size={16}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      left: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      position: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'absolute',
                                                      },
                                                      zIndex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 100,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                />
                                              )}
                                            </>
                                            {/* Custom Code Finance */}
                                            <>
                                              {!(
                                                toggleAddCategoryFinance &&
                                                !toggleNewCategoryFinance
                                              ) ? null : (
                                                <Utils.CustomCodeErrorBoundary>
                                                  <AdditionalCategoryExpenses.Dropdown
                                                    allCategories={
                                                      defaultExpenseCategories.finance_expenses
                                                    }
                                                    setToggleAddCategory={
                                                      setToggleAddCategoryFinance
                                                    }
                                                    setToggleNewCategory={
                                                      setToggleNewCategoryFinance
                                                    }
                                                    sliceValue={10}
                                                    numberInputs={
                                                      numberInputsFinance
                                                    }
                                                    setNumberInputs={
                                                      setNumberInputsFinance
                                                    }
                                                    totalIncomePerCategories={
                                                      totalFinancePerCategory
                                                    }
                                                    setTotalIncomePerCategories={
                                                      setTotalFinancePerCategory
                                                    }
                                                    usersCategories={
                                                      allCategoriesFinance
                                                    }
                                                    setUsersCategories={
                                                      setAllCategoriesFinance
                                                    }
                                                    headType={'_expense_heads'}
                                                  />
                                                </Utils.CustomCodeErrorBoundary>
                                              )}
                                            </>
                                            <>
                                              {toggleAddCategoryFinance ||
                                              toggleNewCategoryFinance ? null : (
                                                <Button
                                                  accessible={true}
                                                  iconPosition={'left'}
                                                  onPress={() => {
                                                    try {
                                                      setToggleAddCategoryFinance(
                                                        true
                                                      );
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  {...GlobalStyles.ButtonStyles(
                                                    theme
                                                  )['Button'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.ButtonStyles(
                                                        theme
                                                      )['Button'].style,
                                                      {
                                                        backgroundColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'rgba(0, 0, 0, 0)',
                                                        },
                                                        color: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'System',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 16,
                                                        },
                                                        fontWeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '600',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                  title={'+'}
                                                />
                                              )}
                                            </>
                                            {/* Custom Category Input */}
                                            <>
                                              {!toggleNewCategoryFinance ? null : (
                                                <TextInput
                                                  autoCapitalize={'none'}
                                                  autoCorrect={true}
                                                  changeTextDelay={500}
                                                  onChangeText={newCustomCategoryInputValue => {
                                                    try {
                                                      setNewCategory(
                                                        newCustomCategoryInputValue
                                                      );
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  onSubmitEditing={() => {
                                                    try {
                                                      /* hidden 'Set Variable' action */
                                                      setAllCategoriesFinance(
                                                        customCategortyExpenses(
                                                          allCategoriesFinance,
                                                          newCategory
                                                        )
                                                      );
                                                      setReRender(!reRender);
                                                      setNumberInputsFinance(
                                                        addNewRow(
                                                          numberInputsFinance
                                                        )
                                                      );
                                                      setTotalFinancePerCategory(
                                                        totalForCategory(
                                                          numberInputsFinance
                                                        )
                                                      );
                                                      setToggleNewCategoryFinance(
                                                        false
                                                      );
                                                      setToggleAddCategoryFinance(
                                                        false
                                                      );
                                                      setNewCategory('');
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  webShowOutline={true}
                                                  {...GlobalStyles.TextInputStyles(
                                                    theme
                                                  )['Text Input'].props}
                                                  autoFocus={true}
                                                  placeholder={
                                                    'Enter New Category'
                                                  }
                                                  placeholderTextColor={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black) ??
                                                    palettes.Brand.White
                                                  }
                                                  selectionColor={
                                                    'rgba(0, 0, 0, 0)'
                                                  }
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextInputStyles(
                                                        theme
                                                      )['Text Input'].style,
                                                      {
                                                        backgroundColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'rgba(0, 0, 0, 0)',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderRadius: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderTopWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        color: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                        ],
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'OpenSans_600SemiBold',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 10,
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                        textAlign: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'right',
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                  value={newCategory}
                                                />
                                              )}
                                            </>
                                          </LinearGradient>
                                        </View>
                                        {/* Totals */}
                                        <View>
                                          {/* Total Expenses */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderBottomWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.White,
                                                },
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Expenses */}
                                            <LinearGradient
                                              color1={
                                                theme.colors.branding.primary
                                              }
                                              color2={
                                                theme.colors.branding.secondary
                                              }
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    maxWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                    width: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {/* Total Expenses */}
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {
                                                  'Subtotal CC, Loan, Donation, Startup & Withdraw Expenses'
                                                }
                                              </Text>
                                            </LinearGradient>
                                            {/* Total List per month */}
                                            <SimpleStyleFlatList
                                              data={totalFinancePerMonth.concat(
                                                [0, 0]
                                              )}
                                              decelerationRate={'normal'}
                                              inverted={false}
                                              keyExtractor={(
                                                totalListPerMonthData,
                                                index
                                              ) =>
                                                totalListPerMonthData?.id ??
                                                totalListPerMonthData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(
                                                  totalListPerMonthData
                                                )
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'z29ZsRaA'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalListPerMonthData =
                                                  item;
                                                return (
                                                  <>
                                                    {/* Total List per month */}
                                                    <LinearGradient
                                                      color1={
                                                        theme.colors.branding
                                                          .primary
                                                      }
                                                      color2={
                                                        theme.colors.branding
                                                          .secondary
                                                      }
                                                      endY={100}
                                                      startX={0}
                                                      startY={0}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Blue Linear'].props}
                                                      endX={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Blue Linear']
                                                            .style,
                                                          {
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .White,
                                                            },
                                                            borderLeftWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            minWidth: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : 75,
                                                              },
                                                            ],
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : cellWidth(),
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : 75,
                                                              },
                                                            ],
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Total List per month */}
                                                      <>
                                                        {!(
                                                          index <= 12
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'$'}
                                                            {formatNumber(
                                                              totalListPerMonthData
                                                            )}
                                                          </Text>
                                                        )}
                                                      </>
                                                      {/* %Income */}
                                                      <>
                                                        {!(
                                                          index === 13
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {calculatePercentIncome(
                                                              Constants[
                                                                'TOTAL_INCOME'
                                                              ],
                                                              totalFinancePerMonth.slice(
                                                                12,
                                                                undefined
                                                              )
                                                            )}
                                                            {'%'}
                                                          </Text>
                                                        )}
                                                      </>
                                                      {/* Benchmark */}
                                                      <>
                                                        {!(
                                                          index === 14
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {null}
                                                          </Text>
                                                        )}
                                                      </>
                                                    </LinearGradient>
                                                  </>
                                                );
                                              }}
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                              horizontal={true}
                                              scrollEnabled={false}
                                              showsHorizontalScrollIndicator={
                                                false
                                              }
                                            />
                                          </View>
                                          {/* Total Cash Paid Out */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.White,
                                                },
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                marginTop: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Cash Paid Out */}
                                            <LinearGradient
                                              color1={
                                                theme.colors.branding.primary
                                              }
                                              color2={
                                                theme.colors.branding.secondary
                                              }
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    justifyContent: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'flex-end',
                                                    },
                                                    maxWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                    width: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {/* Total Cash Paid Out */}
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text'].style,
                                                    {
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 4,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'Total Cash Paid Out'}
                                              </Text>
                                            </LinearGradient>
                                            {/* Total Cash Paid Out */}
                                            <SimpleStyleFlatList
                                              data={totalCashPaidOut.concat([
                                                0, 0,
                                              ])}
                                              decelerationRate={'normal'}
                                              inverted={false}
                                              keyExtractor={(
                                                totalCashPaidOutData,
                                                index
                                              ) =>
                                                totalCashPaidOutData?.id ??
                                                totalCashPaidOutData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(
                                                  totalCashPaidOutData
                                                )
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'d60WUTfg'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalCashPaidOutData =
                                                  item;
                                                return (
                                                  <>
                                                    {/* Total Cash Paid Out */}
                                                    <LinearGradient
                                                      color1={
                                                        theme.colors.branding
                                                          .primary
                                                      }
                                                      color2={
                                                        theme.colors.branding
                                                          .secondary
                                                      }
                                                      endY={100}
                                                      startX={0}
                                                      startY={0}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Blue Linear'].props}
                                                      endX={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Blue Linear']
                                                            .style,
                                                          {
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .White,
                                                            },
                                                            borderLeftWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            minWidth: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : cellWidth(),
                                                              },
                                                            ],
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  index === 14
                                                                    ? 200
                                                                    : cellWidth(),
                                                              },
                                                            ],
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Total Cash Paid Out */}
                                                      <>
                                                        {!(
                                                          index <= 12
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'$'}
                                                            {formatNumber(
                                                              totalCashPaidOutData
                                                            )}
                                                          </Text>
                                                        )}
                                                      </>
                                                      {/* %Income */}
                                                      <>
                                                        {!(
                                                          index === 13
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {calculatePercentIncome(
                                                              Constants[
                                                                'TOTAL_INCOME'
                                                              ],
                                                              totalCashPaidOut.slice(
                                                                12,
                                                                undefined
                                                              )
                                                            )}
                                                            {'%'}
                                                          </Text>
                                                        )}
                                                      </>
                                                      {/* Benchmark */}
                                                      <>
                                                        {!(
                                                          index === 14
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'95-97%'}
                                                          </Text>
                                                        )}
                                                      </>
                                                    </LinearGradient>
                                                  </>
                                                );
                                              }}
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                              horizontal={true}
                                              scrollEnabled={false}
                                              showsHorizontalScrollIndicator={
                                                false
                                              }
                                            />
                                          </View>
                                        </View>
                                      </View>
                                      {/* Other Operating Data */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'flex-end',
                                            },
                                            paddingBottom: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 50,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Header View */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 50,
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'flex-end',
                                              },
                                              padding: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 4,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Header */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Header'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Header'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black,
                                                  },
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_300Light',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 18,
                                                  },
                                                  textAlign: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'right',
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Other Operating Data'}
                                          </Text>
                                        </View>

                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Categories List */}
                                          <SimpleStyleFlatList
                                            data={allCategoriesOther}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(
                                              categoriesListData,
                                              index
                                            ) =>
                                              categoriesListData?.id ??
                                              categoriesListData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(categoriesListData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'7pw76iyb'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const categoriesListData = item;
                                              return (
                                                <View
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      flexDirection: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'row',
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Categories Linear Gradient */}
                                                  <LinearGradient
                                                    endY={100}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    startX={0}
                                                    startY={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .Black,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderTopWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              'space-between',
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              categoriesListData?.default_value ||
                                                              categoriesListData?.custom_value
                                                                ? 'flex-end'
                                                                : 'space-between',
                                                          },
                                                        ],
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        maxWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Remove Button */}
                                                    <>
                                                      {categoriesListData?.default_value ||
                                                      categoriesListData?.custom_value ? null : (
                                                        <IconButton
                                                          onPress={() => {
                                                            try {
                                                              setAllCategoriesOther(
                                                                removeFromCategories(
                                                                  allCategoriesOther,
                                                                  index
                                                                )
                                                              );
                                                              setNumberInputsOther(
                                                                removeFromNumberInputs(
                                                                  index,
                                                                  numberInputsOther
                                                                )
                                                              );
                                                              setTotalOtherPerCategory(
                                                                totalForCategory(
                                                                  numberInputsOther
                                                                )
                                                              );
                                                              /* hidden 'Log to Console' action */
                                                              setReRender(
                                                                !reRender
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          color={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black) ??
                                                            palettes.Brand.White
                                                          }
                                                          icon={
                                                            'AntDesign/minus'
                                                          }
                                                          size={16}
                                                        />
                                                      )}
                                                    </>
                                                    {/* Categories Text */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: null,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .White
                                                                    : palettes
                                                                        .Brand
                                                                        .Black,
                                                              },
                                                            ],
                                                            paddingRight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 4,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {categoriesListData?.custom_value ===
                                                      true
                                                        ? categoriesListData?.title
                                                        : categoriesListData
                                                            ?._expense_heads
                                                            ?.title}
                                                    </Text>
                                                  </LinearGradient>

                                                  <View
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Categories Expenses per month */}
                                                    <SimpleStyleFlatList
                                                      data={[
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ]}
                                                      decelerationRate={
                                                        'normal'
                                                      }
                                                      inverted={false}
                                                      keyExtractor={(
                                                        categoriesExpensesPerMonthData,
                                                        index
                                                      ) =>
                                                        categoriesExpensesPerMonthData?.id ??
                                                        categoriesExpensesPerMonthData?.uuid ??
                                                        index?.toString() ??
                                                        JSON.stringify(
                                                          categoriesExpensesPerMonthData
                                                        )
                                                      }
                                                      keyboardShouldPersistTaps={
                                                        'never'
                                                      }
                                                      listKey={JSON.stringify([
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ])}
                                                      nestedScrollEnabled={
                                                        false
                                                      }
                                                      numColumns={1}
                                                      onEndReachedThreshold={
                                                        0.5
                                                      }
                                                      pagingEnabled={false}
                                                      renderItem={({
                                                        item,
                                                        index,
                                                      }) => {
                                                        const categoriesExpensesPerMonthData =
                                                          item;
                                                        return (
                                                          <LinearGradient
                                                            endY={100}
                                                            startX={0}
                                                            startY={0}
                                                            {...GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )['Inner Gradient']
                                                              .props}
                                                            color1={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]) ??
                                                              'theme.colors["Inner Gradient"]'
                                                            }
                                                            color2={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.App[
                                                                    'Gray Linear Dark'
                                                                  ]
                                                                : palettes.App[
                                                                    'Light Linear - Light'
                                                                  ]) ??
                                                              palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            }
                                                            color3={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]) ??
                                                              'theme.colors["Inner Gradient"]'
                                                            }
                                                            endX={0}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.LinearGradientStyles(
                                                                  theme
                                                                )[
                                                                  'Inner Gradient'
                                                                ].style,
                                                                {
                                                                  maxWidth: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: null,
                                                                  },
                                                                  minWidth: {
                                                                    minWidth:
                                                                      Breakpoints.BigScreen,
                                                                    value:
                                                                      cellWidth(),
                                                                  },
                                                                  width: {
                                                                    minWidth:
                                                                      Breakpoints.BigScreen,
                                                                    value:
                                                                      cellWidth(),
                                                                  },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {/* Number Input 2 */}
                                                            <NumberInput
                                                              changeTextDelay={
                                                                500
                                                              }
                                                              onBlur={() => {
                                                                try {
                                                                  setSelectedIndexOther(
                                                                    addOrRemove(
                                                                      selectedIndexOther,
                                                                      index,
                                                                      findIndexExpense(
                                                                        otherData?.length ===
                                                                          0
                                                                          ? allCategoriesOther
                                                                          : sortCategoriesExpense(
                                                                              allCategoriesOther
                                                                            ),
                                                                        categoriesListData
                                                                      )
                                                                    )
                                                                  );
                                                                } catch (err) {
                                                                  console.error(
                                                                    err
                                                                  );
                                                                }
                                                              }}
                                                              onChangeText={newNumberInput2Value => {
                                                                try {
                                                                  const initData =
                                                                    updateTableRows(
                                                                      index,
                                                                      findIndexExpense(
                                                                        allCategoriesOther,
                                                                        categoriesListData
                                                                      ),
                                                                      newNumberInput2Value >=
                                                                        0
                                                                        ? newNumberInput2Value
                                                                        : 0,
                                                                      numberInputsOther
                                                                    );
                                                                  setTotalOtherPerCategory(
                                                                    totalForCategory(
                                                                      numberInputsOther
                                                                    )
                                                                  );
                                                                } catch (err) {
                                                                  console.error(
                                                                    err
                                                                  );
                                                                }
                                                              }}
                                                              onFocus={() => {
                                                                try {
                                                                  setSelectedIndexOther(
                                                                    addOrRemove(
                                                                      selectedIndexOther,
                                                                      index,
                                                                      findIndexExpense(
                                                                        otherData?.length ===
                                                                          0
                                                                          ? allCategoriesOther
                                                                          : sortCategoriesExpense(
                                                                              allCategoriesOther
                                                                            ),
                                                                        categoriesListData
                                                                      )
                                                                    )
                                                                  );
                                                                } catch (err) {
                                                                  console.error(
                                                                    err
                                                                  );
                                                                }
                                                              }}
                                                              webShowOutline={
                                                                true
                                                              }
                                                              {...GlobalStyles.NumberInputStyles(
                                                                theme
                                                              )[
                                                                'Table Number Input'
                                                              ].props}
                                                              defaultValue={getInitValue(
                                                                numberInputsOther,
                                                                findIndexExpense(
                                                                  otherData?.length ===
                                                                    0
                                                                    ? allCategoriesOther
                                                                    : sortCategoriesExpense(
                                                                        allCategoriesOther
                                                                      ),
                                                                  categoriesListData
                                                                ),
                                                                index
                                                              )}
                                                              placeholder={''}
                                                              style={StyleSheet.applyWidth(
                                                                StyleSheet.compose(
                                                                  GlobalStyles.NumberInputStyles(
                                                                    theme
                                                                  )[
                                                                    'Table Number Input'
                                                                  ].style,
                                                                  {
                                                                    color: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        selectedIndexOther.includes(
                                                                          findColumnRowNumber(
                                                                            index,
                                                                            findIndexExpense(
                                                                              otherData?.length ===
                                                                                0
                                                                                ? allCategoriesOther
                                                                                : sortCategoriesExpense(
                                                                                    allCategoriesOther
                                                                                  ),
                                                                              categoriesListData
                                                                            )
                                                                          )
                                                                        )
                                                                          ? Constants[
                                                                              'SWITCH_SCREEN_MODE'
                                                                            ]
                                                                            ? palettes
                                                                                .Brand
                                                                                .Black
                                                                            : palettes
                                                                                .Brand
                                                                                .White
                                                                          : palettes
                                                                              .Brand
                                                                              .Transparent,
                                                                    },
                                                                    textAlign: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'right',
                                                                    },
                                                                    zIndex: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 1,
                                                                    },
                                                                  }
                                                                ),
                                                                dimensions.width
                                                              )}
                                                            />
                                                            {/* Format View */}
                                                            <>
                                                              {selectedIndexOther.includes(
                                                                findColumnRowNumber(
                                                                  index,
                                                                  findIndexExpense(
                                                                    otherData?.length ===
                                                                      0
                                                                      ? allCategoriesOther
                                                                      : sortCategoriesExpense(
                                                                          allCategoriesOther
                                                                        ),
                                                                    categoriesListData
                                                                  )
                                                                )
                                                              ) ? null : (
                                                                <View
                                                                  style={StyleSheet.applyWidth(
                                                                    {
                                                                      alignItems:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'center',
                                                                        },
                                                                      flexDirection:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'row',
                                                                        },
                                                                      justifyContent:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'space-between',
                                                                        },
                                                                      paddingLeft:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value: 4,
                                                                        },
                                                                      paddingRight:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value: 4,
                                                                        },
                                                                      position:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'absolute',
                                                                        },
                                                                      width: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          '100%',
                                                                      },
                                                                      zIndex: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 0,
                                                                      },
                                                                    },
                                                                    dimensions.width
                                                                  )}
                                                                >
                                                                  {/* $ */}
                                                                  <Text
                                                                    accessible={
                                                                      true
                                                                    }
                                                                    selectable={
                                                                      false
                                                                    }
                                                                    {...GlobalStyles.TextStyles(
                                                                      theme
                                                                    )['Text']
                                                                      .props}
                                                                    style={StyleSheet.applyWidth(
                                                                      StyleSheet.compose(
                                                                        GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].style,
                                                                        {
                                                                          color:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                Constants[
                                                                                  'SWITCH_SCREEN_MODE'
                                                                                ]
                                                                                  ? palettes
                                                                                      .Brand
                                                                                      .Black
                                                                                  : palettes
                                                                                      .Brand
                                                                                      .White,
                                                                            },
                                                                          fontFamily:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'OpenSans_600SemiBold',
                                                                            },
                                                                          fontSize:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 10,
                                                                            },
                                                                        }
                                                                      ),
                                                                      dimensions.width
                                                                    )}
                                                                  >
                                                                    {'$'}
                                                                  </Text>
                                                                  {/* Number Value */}
                                                                  <Text
                                                                    accessible={
                                                                      true
                                                                    }
                                                                    selectable={
                                                                      false
                                                                    }
                                                                    {...GlobalStyles.TextStyles(
                                                                      theme
                                                                    )['Text']
                                                                      .props}
                                                                    style={StyleSheet.applyWidth(
                                                                      StyleSheet.compose(
                                                                        GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].style,
                                                                        {
                                                                          color:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                Constants[
                                                                                  'SWITCH_SCREEN_MODE'
                                                                                ]
                                                                                  ? palettes
                                                                                      .Brand
                                                                                      .Black
                                                                                  : palettes
                                                                                      .Brand
                                                                                      .White,
                                                                            },
                                                                          fontFamily:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'OpenSans_600SemiBold',
                                                                            },
                                                                          fontSize:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 10,
                                                                            },
                                                                        }
                                                                      ),
                                                                      dimensions.width
                                                                    )}
                                                                  >
                                                                    {formatNumber(
                                                                      getInitValue(
                                                                        numberInputsOther,
                                                                        findIndexExpense(
                                                                          otherData?.length ===
                                                                            0
                                                                            ? allCategoriesOther
                                                                            : sortCategoriesExpense(
                                                                                allCategoriesOther
                                                                              ),
                                                                          categoriesListData
                                                                        ),
                                                                        index
                                                                      )
                                                                    )}
                                                                  </Text>
                                                                </View>
                                                              )}
                                                            </>
                                                          </LinearGradient>
                                                        );
                                                      }}
                                                      showsHorizontalScrollIndicator={
                                                        true
                                                      }
                                                      showsVerticalScrollIndicator={
                                                        true
                                                      }
                                                      snapToAlignment={'start'}
                                                      extraData={reRender}
                                                      horizontal={true}
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: '100%',
                                                          },
                                                        },
                                                        dimensions.width
                                                      )}
                                                    />
                                                  </View>
                                                </View>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            extraData={reRender}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          />
                                          {/* Totals */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-start',
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Expense */}
                                            <SimpleStyleFlatList
                                              data={totalOtherPerCategory}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                totalExpenseData,
                                                index
                                              ) =>
                                                totalExpenseData?.id ??
                                                totalExpenseData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(totalExpenseData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'gZ9GUBQ7'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalExpenseData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$'}
                                                      {formatNumber(
                                                        totalExpenseData
                                                      )}
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                            {/* %Of Income */}
                                            <SimpleStyleFlatList
                                              data={calculatePercentIncome(
                                                Constants['TOTAL_INCOME'],
                                                totalOtherPerCategory
                                              )}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                ofIncomeData,
                                                index
                                              ) =>
                                                ofIncomeData?.id ??
                                                ofIncomeData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(ofIncomeData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'j2R17N3K'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const ofIncomeData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: cellWidth(),
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {ofIncomeData}
                                                      {'%'}
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                            {/* Benchmarks */}
                                            <SimpleStyleFlatList
                                              data={allCategoriesOther}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                benchmarksData,
                                                index
                                              ) =>
                                                benchmarksData?.id ??
                                                benchmarksData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(benchmarksData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'XjFq6IVw'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const benchmarksData = item;
                                                return (
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Inner Gradient'].props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Inner Gradient']
                                                          .style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .Black,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 200,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                                ? palettes.Brand
                                                                    .Black
                                                                : palettes.Brand
                                                                    .White,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {
                                                        benchmarksData?.benchmarks
                                                      }
                                                    </Text>
                                                  </LinearGradient>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              extraData={reRender}
                                            />
                                          </View>
                                        </View>
                                        {/* Additional Categories */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              maxHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              minHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Gray Linear Gradient */}
                                          <LinearGradient
                                            endY={100}
                                            color1={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]) ??
                                              palettes.App['Gray Linear Light']
                                            }
                                            color2={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]) ??
                                              palettes.App['Gray Linear Dark']
                                            }
                                            endX={0}
                                            startX={0}
                                            startY={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: [
                                                  {
                                                    minWidth:
                                                      Breakpoints.Desktop,
                                                    value: 'stretch',
                                                  },
                                                  {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'stretch',
                                                  },
                                                ],
                                                borderBottomWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.Black,
                                                },
                                                borderLeftWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderRightWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'center',
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Add Button */}
                                            <>
                                              {toggleAddCategoryOther ? null : (
                                                <Button
                                                  accessible={true}
                                                  iconPosition={'left'}
                                                  onPress={() => {
                                                    try {
                                                      setToggleAddCategoryOther(
                                                        true
                                                      );
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  {...GlobalStyles.ButtonStyles(
                                                    theme
                                                  )['Button'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.ButtonStyles(
                                                        theme
                                                      )['Button'].style,
                                                      {
                                                        backgroundColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'rgba(0, 0, 0, 0)',
                                                        },
                                                        color: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'System',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 16,
                                                        },
                                                        fontWeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '600',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                  title={'+'}
                                                />
                                              )}
                                            </>
                                            {/* Remove Button */}
                                            <>
                                              {!toggleAddCategoryOther ? null : (
                                                <IconButton
                                                  onPress={() => {
                                                    try {
                                                      setToggleAddCategoryOther(
                                                        false
                                                      );
                                                      setToggleNewCategoryOther(
                                                        false
                                                      );
                                                      setNewCategory('');
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  color={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black) ??
                                                    palettes.Brand.White
                                                  }
                                                  icon={'AntDesign/minus'}
                                                  size={16}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      left: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      position: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'absolute',
                                                      },
                                                      zIndex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 100,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                />
                                              )}
                                            </>
                                            <>
                                              {!(
                                                toggleAddCategoryOther &&
                                                !toggleNewCategoryOther
                                              ) ? null : (
                                                <Utils.CustomCodeErrorBoundary>
                                                  <AdditionalCategoryExpenses.Dropdown
                                                    allCategories={
                                                      defaultExpenseCategories.other_operating_data
                                                    }
                                                    setToggleAddCategory={
                                                      setToggleAddCategoryOther
                                                    }
                                                    setToggleNewCategory={
                                                      setToggleNewCategoryOther
                                                    }
                                                    sliceValue={6}
                                                    numberInputs={
                                                      numberInputsOther
                                                    }
                                                    setNumberInputs={
                                                      setNumberInputsOther
                                                    }
                                                    totalIncomePerCategories={
                                                      totalOtherPerCategory
                                                    }
                                                    setTotalIncomePerCategories={
                                                      setTotalOtherPerCategory
                                                    }
                                                    usersCategories={
                                                      allCategoriesOther
                                                    }
                                                    setUsersCategories={
                                                      setAllCategoriesOther
                                                    }
                                                    headType={'_expense_heads'}
                                                  />
                                                </Utils.CustomCodeErrorBoundary>
                                              )}
                                            </>
                                            {/* Custom Category Input */}
                                            <>
                                              {!toggleNewCategoryOther ? null : (
                                                <TextInput
                                                  autoCapitalize={'none'}
                                                  autoCorrect={true}
                                                  changeTextDelay={500}
                                                  onChangeText={newCustomCategoryInputValue => {
                                                    try {
                                                      setNewCategory(
                                                        newCustomCategoryInputValue
                                                      );
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  onSubmitEditing={() => {
                                                    try {
                                                      setAllCategoriesOther(
                                                        customCategortyExpenses(
                                                          allCategoriesOther,
                                                          newCategory
                                                        )
                                                      );
                                                      setReRender(!reRender);
                                                      setNumberInputsOther(
                                                        addNewRow(
                                                          numberInputsOther
                                                        )
                                                      );
                                                      setTotalOtherPerCategory(
                                                        totalForCategory(
                                                          numberInputsOther
                                                        )
                                                      );
                                                      setToggleNewCategoryOther(
                                                        false
                                                      );
                                                      setToggleAddCategoryOther(
                                                        false
                                                      );
                                                      setNewCategory('');
                                                    } catch (err) {
                                                      console.error(err);
                                                    }
                                                  }}
                                                  webShowOutline={true}
                                                  {...GlobalStyles.TextInputStyles(
                                                    theme
                                                  )['Text Input'].props}
                                                  autoFocus={true}
                                                  placeholder={
                                                    'Enter New Category'
                                                  }
                                                  placeholderTextColor={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black) ??
                                                    palettes.Brand.White
                                                  }
                                                  selectionColor={
                                                    'rgba(0, 0, 0, 0)'
                                                  }
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextInputStyles(
                                                        theme
                                                      )['Text Input'].style,
                                                      {
                                                        backgroundColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'rgba(0, 0, 0, 0)',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderRadius: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        borderTopWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 0,
                                                        },
                                                        color: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                        ],
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'OpenSans_600SemiBold',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 10,
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                        textAlign: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'right',
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                  value={newCategory}
                                                />
                                              )}
                                            </>
                                          </LinearGradient>
                                        </View>
                                      </View>
                                    </View>
                                  </SimpleStyleScrollView>
                                </View>
                              </SimpleStyleScrollView>
                            )}
                          </>
                          {/* Button View */}
                          <>
                            {isLoading ? null : (
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    paddingBottom: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 20,
                                    },
                                    paddingTop: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 20,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Submit Button */}
                                <Button
                                  accessible={true}
                                  iconPosition={'left'}
                                  onPress={() => {
                                    const handler = async () => {
                                      try {
                                        setIsLoading(true);
                                        setIsFetching(true);
                                        const cogsData = mergeCategoriesNumbers(
                                          allCategoriesPayment,
                                          numberInputsPaymentForCost,
                                          Constants['STARTING_DATE']
                                        );
                                        const operatingData =
                                          mergeCategoriesNumbers(
                                            allCategoriesOperating,
                                            numberInputsOperating,
                                            Constants['STARTING_DATE']
                                          );
                                        const financeData =
                                          mergeCategoriesNumbers(
                                            allCategoriesFinance,
                                            numberInputsFinance,
                                            Constants['STARTING_DATE']
                                          );
                                        const otherData =
                                          mergeCategoriesNumbers(
                                            allCategoriesOther,
                                            numberInputsOther,
                                            Constants['STARTING_DATE']
                                          );
                                        const response = (
                                          await defaultPostExpensesPOST.mutateAsync(
                                            {
                                              expenses: createObjectForPost(
                                                cogsData,
                                                financeData,
                                                otherData,
                                                operatingData
                                              ),
                                              starting_cash_values:
                                                createStartingBalance(
                                                  Constants['STARTING_DATE'],
                                                  monthlyStartingBalance
                                                ),
                                            }
                                          )
                                        )?.json;
                                        setReFetch(false);
                                        setIsFetching(false);
                                      } catch (err) {
                                        console.error(err);
                                      }
                                    };
                                    handler();
                                  }}
                                  {...GlobalStyles.ButtonStyles(theme)['Button']
                                    .props}
                                  loading={isLoading}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.ButtonStyles(theme)['Button']
                                        .style,
                                      {
                                        backgroundColor: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand['App Green'],
                                        },
                                        width: {
                                          minWidth: Breakpoints.Laptop,
                                          value: '25%',
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                  title={'Submit'}
                                />
                              </View>
                            )}
                          </>
                        </>
                      );
                    }}
                  </DefaultApi.FetchGetExpenseHeadsGET>
                )}
              </>
              {/* Loading View 2 */}
              <>
                {!(isLoading || isFetching) ? null : (
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.App['Black %50'],
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        gap: { minWidth: Breakpoints.Laptop, value: 20 },
                        height: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.height,
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        position: {
                          minWidth: Breakpoints.Laptop,
                          value: 'absolute',
                        },
                        width: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              dimensions.width - dimensions.width * (15 / 100),
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              dimensions.width - dimensions.width * (20 / 100),
                          },
                        ],
                      },
                      dimensions.width
                    )}
                  >
                    <ActivityIndicator
                      animating={true}
                      hidesWhenStopped={true}
                      {...GlobalStyles.ActivityIndicatorStyles(theme)[
                        'Activity Indicator'
                      ].props}
                      size={'large'}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.ActivityIndicatorStyles(theme)[
                          'Activity Indicator'
                        ].style,
                        dimensions.width
                      )}
                    />
                    {/* Message */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Header'].style,
                        dimensions.width
                      )}
                    >
                      {'Loading, please wait...'}
                    </Text>
                  </View>
                )}
              </>
            </View>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(ExpensesFormScreen);
